
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("jtfsl", function(module, exports) {
/**
 * @generated SignedSource<<aca1485c81f4c332fddb954ffe51db21>>
 * @relayHash 0dd246a45e06b932ab1b8570b0e2a26f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63
const $8272d98e33ae5f0d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accountId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "accountId"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Group",
                            "kind": "LinkedField",
                            "name": "groupsWithId",
                            "plural": true,
                            "selections": [
                                v1 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AudienceSegmentationContextProviderQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "0dd246a45e06b932ab1b8570b0e2a26f",
            "id": "9541c3f7c90ad9f1ab645d0b30662e1e580d7fd7e0951e7703e0bf175d12bd63",
            "metadata": {},
            "name": "AudienceSegmentationContextProviderQuery",
            "operationKind": "query",
            "text": "query AudienceSegmentationContextProviderQuery($accountId:ID){user:confluence_atlassianUser(id:$accountId){id,confluence{groupsWithId{id}}}}"
        }
    };
}();
$8272d98e33ae5f0d$var$node.hash = "d01bf7959fed02b6636fa27826de406a";
var $8272d98e33ae5f0d$export$2e2bcd8739ae039 = $8272d98e33ae5f0d$var$node;
module.exports["default"] = $8272d98e33ae5f0d$export$2e2bcd8739ae039;

});

parcelRegister("kLzei", function(module, exports) {
/* getSmartCardRenderers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $2XqLN = parcelRequire("2XqLN");


var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $i5WUp = parcelRequire("i5WUp");


var $di8q4 = parcelRequire("di8q4");


var $9wGTI = parcelRequire("9wGTI");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $1431e51c33a3f61c$var$emojiWrapperStyles = null;
const $1431e51c33a3f61c$var$SmartCardEmojiWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1reo15vq _18m915vq _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1o8l _1bah1h6o _1ul97vkz"
        ])
    }, children); // Custom render wrapper for AISnippet providing session data
const $1431e51c33a3f61c$var$AISnippetRenderer = (props)=>{
    const { displayName: displayName, userId: userId, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)(); // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    if (!isAdminHubAIEnabled || !isAIFeatureEnabled || !(0, $6mKj3.expVal)('confluence-ai-linking-ai-snippets', 'should_render_ai_snippet', false)) return props.fallbackComponent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $i5WUp.AISnippetWithRelayEnvironment), {
        ...props,
        showAwareness: true,
        userId: userId ?? undefined,
        displayName: displayName ?? undefined
    });
};
const $1431e51c33a3f61c$export$61bc672a900b57f = (0, $2XqLN.default)(()=>({
        renderers: {
            emoji: (emojiId, _parentComponent = 'SmartCard', contentType = 'page')=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ge2sX.SessionData), null, (sessionData)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                        value: sessionData
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                        emoji: emojiId,
                        height: 16,
                        context: "smartCard",
                        wrapper: $1431e51c33a3f61c$var$SmartCardEmojiWrapper,
                        contentType: contentType
                    }))),
            snippet: (0, $9wGTI.fg)('cc-ai-snippet-renderer-gate') ? $1431e51c33a3f61c$var$AISnippetRenderer : undefined
        }
    }));
module.exports["getSmartCardRenderers"] = $1431e51c33a3f61c$export$61bc672a900b57f;

});

parcelRegister("2SowE", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ function $3c96f0e6009ebcf8$export$dc64ca688fb64c26(payload, newAttributes) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            ...newAttributes
        }
    };
}
const $3c96f0e6009ebcf8$export$a9a68a8b41555f13 = (startTime, duration)=>{
    return Number.isFinite(startTime) && Number.isFinite(duration) ? Math.round(startTime + duration) : undefined;
};
const $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6 = (context)=>{
    return context.filter((obj)=>obj.attributes && typeof obj.attributes === 'object' && !Array.isArray(obj.attributes)).reduce((acc, obj)=>({
            ...acc,
            ...obj.attributes
        }), {});
};
module.exports["extendPayloadAttributes"] = $3c96f0e6009ebcf8$export$dc64ca688fb64c26;
module.exports["getProseMirrorFMPTimestamp"] = $3c96f0e6009ebcf8$export$a9a68a8b41555f13;
module.exports["extractAttributesFromContext"] = $3c96f0e6009ebcf8$export$7ed9e23d68ab9aa6;

});

parcelRegister("hEeUR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $gqqjz = parcelRequire("gqqjz");


var $jxpvN = parcelRequire("jxpvN");


var $1a6Dn = parcelRequire("1a6Dn");


var $hrAmX = parcelRequire("hrAmX");


var $8WfxO = parcelRequire("8WfxO");





var $3jwuS = parcelRequire("3jwuS");


var $6mKj3 = parcelRequire("6mKj3");

const $134d01bd64a6ba9b$export$e43ca933d3c87145 = ()=>{
    const [forgeAppsHeight, setForgeAppsHeight] = (0, $42omo.useState)($134d01bd64a6ba9b$var$getForgeAppsHeight());
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isForgePageBannerFixed = !isLivePage;
    (0, $42omo.useEffect)(()=>{
        const listener = (e)=>{
            if ((0, $6mKj3.expVal)('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) setForgeAppsHeight(e?.detail?.height ?? 0);
            else setForgeAppsHeight($134d01bd64a6ba9b$var$getForgeAppsHeight());
        };
        if (isForgePageBannerFixed) document.addEventListener('forgePageBannerHeightUpdated', listener);
        return ()=>{
            if (isForgePageBannerFixed) document.removeEventListener('forgePageBannerHeightUpdated', listener);
        };
    }, [
        isForgePageBannerFixed
    ]);
    return {
        isForgePageBannerFixed: isForgePageBannerFixed,
        forgePageBannerHeight: forgeAppsHeight
    };
};
const $134d01bd64a6ba9b$var$getForgeAppsHeight = ()=>{
    if (typeof document === 'undefined') return 0;
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--forge-page-banner-height')) || 0;
};



var $gz8ZY = parcelRequire("gz8ZY");


var $fyKZ5 = parcelRequire("fyKZ5");

const $2a9f51add9ac11ab$export$7cfa481653c48265 = /*#__PURE__*/ (0, $42omo.memo)((0, $3u0dr.isReactCompilerActiveV1)() ? (props)=>{
    const $ = (0, $frIzR.c)(7);
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { includeTopNav: includeTopNav } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const { atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const { forgePageBannerHeight: forgePageBannerHeight } = (0, $134d01bd64a6ba9b$export$e43ca933d3c87145)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            (0, $gqqjz.FlagsStateContainer),
            (0, $hrAmX.BannerStateContainer),
            (0, $1a6Dn.FloatingBannerStateContainer)
        ];
        $[0] = t0;
    } else t0 = $[0];
    let t1;
    if ($[1] !== atlGeneralWebPanelHeight || $[2] !== forgePageBannerHeight || $[3] !== includeTopNav || $[4] !== isNav4Enabled || $[5] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
            to: t0
        }, (flags, bannerState, floatingBanners)=>{
            const topNavAndBannerHeight = bannerState.getTotalHeight(includeTopNav);
            const forgePageBannerHeightFeatureFlagged = forgePageBannerHeight;
            const pageHeaderAndBannerHeight = floatingBanners.getFloatingHeight() + (props.isContentHeaderFixedAtTop ? 55 + atlGeneralWebPanelHeight + forgePageBannerHeightFeatureFlagged : 0);
            const stickyTableHeaderOffsetTopForNav3 = topNavAndBannerHeight + pageHeaderAndBannerHeight;
            const stickyTableHeaderOffsetTopForNav4 = pageHeaderAndBannerHeight;
            let stickyTableHeaderConfig = {
                offsetTop: stickyTableHeaderOffsetTopForNav3
            };
            if (isNav4Enabled) stickyTableHeaderConfig = {
                offsetTop: stickyTableHeaderOffsetTopForNav4,
                defaultScrollRootId_DO_NOT_USE: "AkMainContent",
                shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: true
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyKZ5.ADFRendererComponent), {
                flags: flags,
                ...stickyTableHeaderConfig,
                ...props
            });
        });
        $[1] = atlGeneralWebPanelHeight;
        $[2] = forgePageBannerHeight;
        $[3] = includeTopNav;
        $[4] = isNav4Enabled;
        $[5] = props;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
} : (props)=>{
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { includeTopNav: includeTopNav } = (0, $42omo.useContext)((0, $jxpvN.BannerContext));
    const { atlGeneralWebPanelHeight: atlGeneralWebPanelHeight } = (0, $8WfxO.useATLGeneralWebPanelListener)();
    const { forgePageBannerHeight: forgePageBannerHeight } = (0, $134d01bd64a6ba9b$export$e43ca933d3c87145)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer),
            (0, $hrAmX.BannerStateContainer),
            (0, $1a6Dn.FloatingBannerStateContainer)
        ]
    }, (flags, bannerState, floatingBanners)=>{
        const topNavAndBannerHeight = bannerState.getTotalHeight(includeTopNav);
        // if page header is fixed at the top, it adds extra 55px offset
        // However, when there is a theme applied to a space, page headers are not fixed at the top and will not require additional offset.
        const forgePageBannerHeightFeatureFlagged = forgePageBannerHeight;
        const pageHeaderAndBannerHeight = floatingBanners.getFloatingHeight() + (props.isContentHeaderFixedAtTop ? 55 + atlGeneralWebPanelHeight + forgePageBannerHeightFeatureFlagged : 0);
        const stickyTableHeaderOffsetTopForNav3 = topNavAndBannerHeight + pageHeaderAndBannerHeight;
        // topNavAndBannerHeight is outside the scroll root in Nav4
        const stickyTableHeaderOffsetTopForNav4 = pageHeaderAndBannerHeight;
        let stickyTableHeaderConfig = {
            offsetTop: stickyTableHeaderOffsetTopForNav3
        };
        if (isNav4Enabled) stickyTableHeaderConfig = {
            offsetTop: stickyTableHeaderOffsetTopForNav4,
            defaultScrollRootId_DO_NOT_USE: 'AkMainContent',
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: true
        };
        // WARNING: PERFORMANCE: <ADFRendererComponent> has been split out from <ADFRenderer>
        // because the child function of <Subscribe> component is called 4-5 times per every
        // transition or initial load. This caused AkRenderer component to be re-rendered the
        // same amount of times, which is quite bad for performance. Split allows to memoize
        // the <ADFRendererComponent> and render it only once.
        //
        // The fact that <ADFRenderer> is used for comments as well makes it even more
        // important to *not* re-render AkRenderer more than once for a page or comment.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fyKZ5.ADFRendererComponent), {
            flags: flags,
            ...stickyTableHeaderConfig,
            ...props
        });
    });
});
$2a9f51add9ac11ab$export$7cfa481653c48265.displayName = 'ADFRenderer';
module.exports["ADFRenderer"] = $2a9f51add9ac11ab$export$7cfa481653c48265;

});

parcelRegister("fyKZ5", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $477dG = parcelRequire("477dG");


var $4FxUL = parcelRequire("4FxUL");


var $ibzAc = parcelRequire("ibzAc");


var $67O0h = parcelRequire("67O0h");


var $dh538 = parcelRequire("dh538");


var $1iSzD = parcelRequire("1iSzD");


var $lJlG6 = parcelRequire("lJlG6");


var $7VJPz = parcelRequire("7VJPz");


var $8cjD5 = parcelRequire("8cjD5");


var $fgQGl = parcelRequire("fgQGl");


var $lhTEt = parcelRequire("lhTEt");


var $i6Ps3 = parcelRequire("i6Ps3");


var $hSHWm = parcelRequire("hSHWm");





var $4cOi8 = parcelRequire("4cOi8");

var $cNwLI = parcelRequire("cNwLI");


var $kcoxM = parcelRequire("kcoxM");


var $lf1vG = parcelRequire("lf1vG");


var $cVaAA = parcelRequire("cVaAA");


var $5Ac5G = parcelRequire("5Ac5G");


var $jmjWc = parcelRequire("jmjWc");


var $bl1ay = parcelRequire("bl1ay");


var $cbvYp = parcelRequire("cbvYp");


const $044598a12ce14eec$export$b55cedbe49066c7 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "lL-x8",
    name: "CardsExtensionLoader",
    loader: async ()=>(await (parcelRequire("6iyAr"))).CardsExtension
});

const $044598a12ce14eec$var$PlatformSpotlightExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "d8j05",
    name: "PlatformSpotlightExtensionLoader",
    loader: async ()=>(await (parcelRequire("9YRbs"))).SpotlightExtension
});

const $044598a12ce14eec$var$PlatformSearchExtensionLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "24LHW",
    name: "PlatformSearchExtensionLoader",
    loader: async ()=>(await (parcelRequire("eLvUt"))).CustomSearchExtension
});

const $044598a12ce14eec$var$LinksMenuLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "khj-w",
    name: "LinksMenuLoader",
    loader: async ()=>(await (parcelRequire("1Ex9G"))).LinksMenu
});

const $044598a12ce14eec$var$CarouselLoader = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "iP7CN",
    name: "CarouselLoader",
    loader: async ()=>(await (parcelRequire("4sVPG"))).Carousel
});
const $044598a12ce14eec$export$2a3fa2b29e6e4046 = ({ contentId: contentId })=>{
    const extensionHandlers = {
        [(0, $kcoxM.CARDS_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $5Ac5G.carouselExtensionType)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $cVaAA.LINKS_MENU_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null),
        [(0, $lf1vG.SEARCH_EXTENSION_TYPE)]: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
    };
    if (contentId) {
        extensionHandlers[0, $kcoxM.CARDS_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$export$b55cedbe49066c7, {
                extensionNode: extension,
                contentId: contentId,
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $5Ac5G.carouselExtensionType] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$CarouselLoader, {
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $cVaAA.LINKS_MENU_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$LinksMenuLoader, {
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                extensionNode: extension,
                contentId: contentId,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $cNwLI.SPOTLIGHT_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$PlatformSpotlightExtensionLoader, {
                contentId: contentId,
                extensionNode: extension,
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
        extensionHandlers[0, $bl1ay.HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE] = ()=>null;
        extensionHandlers[0, $lf1vG.SEARCH_EXTENSION_TYPE] = (extension)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($044598a12ce14eec$var$PlatformSearchExtensionLoader, {
                mode: (0, $4cOi8.ExtensionMode).RENDERER,
                contentId: contentId,
                extensionNode: extension,
                propsProvider: (0, $cbvYp.ConfluenceDependenciesProvider)
            });
    }
    return extensionHandlers;
};



var $7BsWq = parcelRequire("7BsWq");


var $brsfB = parcelRequire("brsfB");



var $gXrHX = parcelRequire("gXrHX");


var $1SPMi = parcelRequire("1SPMi");


var $yuV6Z = parcelRequire("yuV6Z");


var $kLzei = parcelRequire("kLzei");

function $0cc2e310acfcea5e$export$6eb9f199796a82af(extensionParams) {
    return Boolean(extensionParams.type === 'bodiedExtension' && extensionParams.parameters?.macroParams?.['atlassian-macro-output-type']?.value === 'INLINE');
}



var $iP9x4 = parcelRequire("iP9x4");


var $3WO8q = parcelRequire("3WO8q");

var $gxhb8 = parcelRequire("gxhb8");


var $dtVue = parcelRequire("dtVue");


var $4IoVL = parcelRequire("4IoVL");


var $32x2E = parcelRequire("32x2E");


var $8WQTF = parcelRequire("8WQTF");


var $jyPfN = parcelRequire("jyPfN");


var $7W8i8 = parcelRequire("7W8i8");



var $ep3mz = parcelRequire("ep3mz");


var $gj42z = parcelRequire("gj42z");


var $4GlQ9 = parcelRequire("4GlQ9");


var $dPJCf = parcelRequire("dPJCf");


var $4o1RV = parcelRequire("4o1RV");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $e4o8D = parcelRequire("e4o8D");


var $6M71K = parcelRequire("6M71K");


var $9aXRY = parcelRequire("9aXRY");


var $dXIrr = parcelRequire("dXIrr");


var $9Eka4 = parcelRequire("9Eka4");


var $edEsl = parcelRequire("edEsl");


var $04e9M = parcelRequire("04e9M");


var $hp2SH = parcelRequire("hp2SH");


var $eXfot = parcelRequire("eXfot");

async function $ad68e9e7df73622d$export$ee66267d3930a21(contentId, batch) {
    const updateBatch = batch.map((update)=>{
        const { objectKey: objectKey, state: state } = update;
        const status = state === 'DONE' ? 'CHECKED' : 'UNCHECKED';
        return {
            taskId: objectKey.localId,
            status: status
        };
    });
    const taskBatch = {
        contentId: contentId,
        tasks: updateBatch,
        trigger: 'VIEW_PAGE'
    };
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        return await (0, $hp2SH.getApolloClient)().mutate({
            mutation: (0, $eXfot.SetBatchedTaskStatusMutation),
            variables: taskBatch
        });
    } catch (error) {
        const client = await (0, $04e9M.getAnalyticsWebClient)();
        client.sendOperationalEvent({
            source: 'page',
            action: 'batchTaskUpdate',
            actionSubject: 'checkbox',
            attributes: {
                error: error.message || String(error),
                stack: error.stack
            }
        });
    }
}



var $kyRHQ = parcelRequire("kyRHQ");

const $1af8a83cb114ff50$export$3422b9c70e187e34 = {
    enabled: true,
    severityDegradedThreshold: 4747,
    severityNormalThreshold: 3775
};
const $1af8a83cb114ff50$var$logger = (0, $7W8i8.getLogger)('ADFRenderer');
const $1af8a83cb114ff50$export$c02e908ea3c1fe52 = {
    enabled: true,
    thresholds: {
        blocking: 1.5,
        degraded: 1
    }
};
const $1af8a83cb114ff50$var$mergeDataProviders = ({ hasViewUserProfilePermission: hasViewUserProfilePermission, handleActionToggle: handleActionToggle, handleInviteItemClick: handleInviteItemClick, getDataProviders: getDataProviders, providerFactory: providerFactory, isExternalShare: isExternalShare, contentId: contentId, spaceKey: spaceKey, pageContextContentId: pageContextContentId, cloudId: cloudId, userId: userId, userRole: userRole, flags: flags, profilecardProvider: profilecardProvider, intl: intl, mediaToken: mediaToken, emojiResourceParams: emojiResourceParams })=>{
    const providers = {};
    if (getDataProviders) Object.assign(providers, getDataProviders());
    if (contentId || mediaToken) {
        providers.mediaProvider = (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            spaceKey: spaceKey,
            mediaDspContentId: pageContextContentId,
            isExternalShare: isExternalShare,
            mediaToken: mediaToken
        });
        providers.taskDecisionProvider = Promise.resolve(new (0, $3WO8q.ConfluenceTaskDecisionProvider)(intl, flags, contentId, handleActionToggle));
    }
    if (cloudId && userId) providers.mentionProvider = (0, $dtVue.createMentionsConfig)(cloudId, userId, undefined, undefined, handleInviteItemClick, userRole).then((config)=>config.mentionResource).catch((err)=>{
        if ($kyRHQ.env.NODE_ENV !== 'production') $1af8a83cb114ff50$var$logger.error`Failed to initialise mention resource ${err}`;
        return Promise.reject();
    });
    if (emojiResourceParams && cloudId) providers.emojiProvider = (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
        ...emojiResourceParams,
        allowAnonymousAccess: true
    });
    if (cloudId) // If global view user profile is enabled then user can view profile card
    {
        if (hasViewUserProfilePermission) providers.profilecardProvider = profilecardProvider;
    }
    if (contentId && spaceKey) providers.contextIdentifierProvider = Promise.resolve({
        containerId: spaceKey,
        objectId: contentId,
        product: 'confluence'
    });
    providers.cardProvider = Promise.resolve(new (0, $477dG.EditorCardProvider)(undefined, undefined, 'CONFLUENCE'));
    const keys = Object.keys(providers);
    if (keys.length) {
        providerFactory = providerFactory || (0, $4FxUL.default).create({});
        for (const provider of Object.keys(providers))providerFactory.setProvider(provider, providers[provider]);
    }
    return {
        providerFactory: providerFactory,
        providers: providers
    };
};
const $1af8a83cb114ff50$var$projectLinkerHandlers = {
    'com.atlassian.confluence.project-linker': ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null)
};
const $1af8a83cb114ff50$export$58eac04eb6213951 = ()=>(0, $dh538.fg)('platform_renderer_unsupported_content_tracking') ? $1af8a83cb114ff50$export$c02e908ea3c1fe52 : undefined;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS = {};
const $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS = ()=>$1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS;
const $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES = [];
const $1af8a83cb114ff50$export$cec675c14d32c246 = /*#__PURE__*/ (0, $42omo.memo)((props)=>{
    const { document: document, dataProviders: dataProviders, extensionHandlers: extensionHandlers = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_HANDLERS, getExtensionHandlers: getExtensionHandlers = $1af8a83cb114ff50$var$DEFAULT_GET_EXTENSION_HANDLERS, eventHandlers: eventHandlers, appearance: appearance, contentMode: contentMode, adfStage: adfStage = 'stage0', portal: portal, onRendered: onRendered, renderWhenReady: renderWhenReady, allowStickyHeaders: allowStickyHeaders = true, allowPlaceholderText: allowPlaceholderText = false, isTruncatedContent: isTruncatedContent, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, flags: flags, offsetTop: offsetTop, defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE, shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE, mediaToken: mediaToken, onError: onError, UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment = true, UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing = true, UNSTABLE_isPresentational: UNSTABLE_isPresentational = false, extensionViewportSizes: extensionViewportSizes = $1af8a83cb114ff50$var$DEFAULT_EXTENSION_VIEWPORT_SIZES, onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail, allowRendererContainerStyles: allowRendererContainerStyles, ...rest } = props;
    const intl = (0, $8C5kA.default)();
    const [isTaskToggled, setIsTaskToggled] = (0, $42omo.useState)(false);
    const initialState = window['__SSR_SMARTLINKS__'];
    const isPageSSR = (0, $i6Ps3.isPageSSRd)();
    const storeOptions = (0, $lhTEt.useStoreOptions)(initialState, isPageSSR);
    // Fix for HOT-99954 - Issue where embedded pages SSR SmartLinks open in same tab
    const shouldSSRsmartLinks = isPageSSR && !(0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)() && !(0, $lJlG6.isMobileApp_DO_NOT_USE)();
    const { cloudId: cloudId, userId: userId, featureFlags: featureFlags, isLicensed: isLicensed, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [pageContextContentId] = (0, $ep3mz.usePageContentId)();
    const [pageContextContentType] = (0, $ep3mz.useContentType)();
    const { openCoreInvites: openCoreInvites, userRole: userRole } = (0, $42omo.useContext)((0, $hSHWm.CoreInvitesContext));
    const [shouldRefetchContent, setShouldRefetchContent] = (0, $42omo.useState)(false);
    const contentId = props.contentId || pageContextContentId;
    const contentType = props.contentType || pageContextContentType;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const taskBatcherRef = (0, $42omo.useRef)(new (0, $gxhb8.TaskBatcher)((0, $6mKj3.expVal)('confluence_frontend_task_batching_interval', 'value', 3000)));
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    // Handlers for batched task update
    const handleBatchTaskUpdate = (0, $42omo.useCallback)((batch)=>{
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        (0, $ad68e9e7df73622d$export$ee66267d3930a21)(contentId, batch).then(()=>{
            setIsTaskToggled(false);
            setShouldRefetchContent(true);
        });
    }, [
        contentId,
        setShouldRefetchContent
    ]);
    const handleActionToggle = (0, $42omo.useCallback)((objectKey, state)=>{
        setIsTaskToggled(true);
        taskBatcherRef.current.add({
            objectKey: objectKey,
            state: state
        });
    }, [
        taskBatcherRef
    ]);
    (0, $42omo.useEffect)(()=>{
        // there is a document check - we do not want to call registerGlobalMediaViewedListener
        // with no content
        if (document) (0, $edEsl.registerGlobalMediaViewedListener)({
            contentType: contentType
        });
        onRendered && onRendered();
        taskBatcherRef.current.onFlush(handleBatchTaskUpdate);
        return ()=>{
            if (document) (0, $edEsl.removeGlobalMediaViewedListener)();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        taskBatcherRef,
        handleBatchTaskUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        setShouldRefetchContent(false);
    // WS-4098 - When the contentId changes or when we mount we don't need to refetch
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        contentId
    ]);
    (0, $42omo.useEffect)(()=>{
        const handleBeforeUnload = (event)=>{
            if (isTaskToggled) {
                event.preventDefault();
                event.returnValue = ''; // This triggers the alert in all browsers
            }
        };
        window.addEventListener('beforeunload', handleBeforeUnload);
        return ()=>{
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTaskToggled,
        contentId
    ]);
    // Setting up emoji resources for ssr and data providers
    const emojiResourceParams = (0, $42omo.useMemo)(()=>{
        if (cloudId) return (0, $yuV6Z.createEmojiProviderParameters)({
            cloudId: cloudId,
            userId: userId,
            isLicensed: isLicensed,
            isLoggedIn: isLoggedIn,
            onEmojiLoadSuccess: onEmojiLoadSuccess,
            onEmojiLoadFail: onEmojiLoadFail
        });
    }, [
        cloudId,
        userId,
        isLicensed,
        isLoggedIn,
        onEmojiLoadSuccess,
        onEmojiLoadFail
    ]);
    const emojiResourceConfig = (0, $42omo.useMemo)(()=>{
        if (emojiResourceParams) return (0, $32x2E.getEmojiConfig)(emojiResourceParams.cloudId, emojiResourceParams.userId, emojiResourceParams.disableUpload, emojiResourceParams.emojiSSRConfig, undefined, emojiResourceParams.emojiLoadCallbacks);
    }, [
        emojiResourceParams
    ]);
    const { isExternalShareRequest: isExternalShareRequest } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const mergedExtensionHandlers = (0, $42omo.useMemo)(()=>{
        return {
            ...getExtensionHandlers?.(),
            ...extensionHandlers,
            ...(0, $044598a12ce14eec$export$2a3fa2b29e6e4046)({
                contentId: contentId
            }),
            ...(0, $7VJPz.getRendererSmartButtonExtensionHandlers)({
                contentId: contentId,
                contentType: contentType,
                cloudId: cloudId
            }),
            ...$1af8a83cb114ff50$var$projectLinkerHandlers
        };
    }, [
        extensionHandlers,
        getExtensionHandlers,
        contentId,
        contentType,
        cloudId
    ]);
    const mediaSSR = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        spaceKey: spaceKey,
        isExternalShare: isExternalShareRequest,
        mediaToken: mediaToken
    });
    // -- Matches fabric-feature-flags.ts
    const isStickyHeadersEnabled = allowStickyHeaders;
    const errorHandler = (0, $42omo.useCallback)((error)=>{
        onError?.(error);
    }, [
        onError
    ]);
    const { shimAdfUrls: shimAdfUrls } = (0, $4o1RV.useNavigationPolicy)();
    const editorFeatureFlags = (0, $7BsWq.useEditorFeatureFlags)();
    const profilecardProvider = (0, $brsfB.useProfilecardProvider)({
        push: push,
        userId: userId,
        cloudId: cloudId,
        featureFlags: featureFlags
    });
    const shouldControlDataExport = (0, $4IoVL.controlDataExportOnCertainFeatures)(window.location.pathname);
    // ----------------------------------
    const allowHeadingAnchorLinks = (0, $42omo.useMemo)(()=>({
            allowNestedHeaderLinks: true,
            activeHeadingId: props.queryHash
        }), [
        props.queryHash
    ]);
    const media = (0, $42omo.useMemo)(()=>({
            allowLinking: true,
            allowCaptions: true,
            featureFlags: {
                mediaInline: true
            },
            ssr: mediaSSR
        }), [
        mediaSSR
    ]);
    const { isEligibleCreateNewWhiteboard: isEligibleCreateNewWhiteboard } = (0, $9aXRY.useIsEligibleCreateNewWhiteboard)();
    const smartLinks = (0, $42omo.useMemo)(()=>({
            ssr: shouldSSRsmartLinks,
            hideHoverPreview: false,
            CompetitorPrompt: isEligibleCreateNewWhiteboard ? (0, $dXIrr.PromptPopupContainer) : undefined
        }), [
        shouldSSRsmartLinks,
        isEligibleCreateNewWhiteboard
    ]);
    const stickyHeaders = (0, $42omo.useMemo)(()=>isStickyHeadersEnabled ? {
            offsetTop: offsetTop,
            defaultScrollRootId_DO_NOT_USE: defaultScrollRootId_DO_NOT_USE,
            shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE: shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
        } : undefined, [
        isStickyHeadersEnabled,
        offsetTop,
        defaultScrollRootId_DO_NOT_USE,
        shouldAddDefaultScrollRootOffsetTop_DO_NOT_USE
    ]);
    const mergedDataProviders = (0, $42omo.useMemo)(()=>$1af8a83cb114ff50$var$mergeDataProviders({
            contentId: // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
            contentId,
            spaceKey: // @ts-ignore FIXME: `spaceKey` can be `undefined` here, and needs proper handling
            spaceKey,
            pageContextContentId: pageContextContentId,
            cloudId: cloudId,
            userId: userId,
            flags: flags,
            featureFlags: featureFlags,
            push: push,
            intl: intl,
            providerFactory: dataProviders,
            profilecardProvider: profilecardProvider,
            isExternalShare: isExternalShareRequest,
            handleActionToggle: handleActionToggle,
            hasViewUserProfilePermission: hasViewUserProfilePermission,
            handleInviteItemClick: openCoreInvites,
            userRole: userRole,
            mediaToken: mediaToken,
            emojiResourceParams: emojiResourceParams
        }), [
        contentId,
        spaceKey,
        pageContextContentId,
        cloudId,
        userId,
        flags,
        featureFlags,
        push,
        intl,
        dataProviders,
        profilecardProvider,
        isExternalShareRequest,
        handleActionToggle,
        hasViewUserProfilePermission,
        openCoreInvites,
        userRole,
        mediaToken,
        emojiResourceParams
    ]);
    const SyncedBlockNodeComponent = (0, $9Eka4.useMemoizedSyncedBlockProviderNodeComponent)({
        doc: document,
        contentId: contentId,
        contentType: contentType,
        mergedDataProviderDefinitions: mergedDataProviders.providers
    });
    const nodeComponents = (0, $42omo.useMemo)(()=>{
        if (SyncedBlockNodeComponent) return {
            syncBlock: SyncedBlockNodeComponent
        };
    }, [
        SyncedBlockNodeComponent
    ]);
    // If its confluence page
    // Store the finalDocument ADF in context so it can be accessed by comment editor
    const { setPageAdf: setPageAdf } = (0, $8WQTF.useRendererActionsDispatch)();
    (0, $42omo.useEffect)(()=>{
        if ((0, $dh538.fg)('platform_editor_aifc_in_page_comment')) {
            if (appearance === 'full-page' || appearance === 'full-width' || appearance === 'max') {
                if (document) {
                    const finalDocument = shimAdfUrls(document);
                    setPageAdf(finalDocument);
                } else setPageAdf(undefined);
            }
        }
    }, [
        appearance,
        document,
        setPageAdf,
        shimAdfUrls
    ]);
    if (!document) return null;
    const finalDocument = shimAdfUrls(document);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (appearance === 'full-page' || appearance === 'full-width') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8cjD5.PageLoadMark), {
        "data-testid": "pageLoadMarkTestId",
        name: "onBeforeAkRenderer"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1SPMi.RendererAnalyticsListener), {
        // @ts-ignore FIXME: `contentId` can be `undefined` here, and needs proper handling
        objectId: contentId,
        objectType: contentType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $67O0h.RendererWithAnalytics), {
        // This flag is used for fixing table width in SSR mode and for hydration
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        enableSsrInlineScripts: Boolean(undefined),
        // include renderer inline script from above on first render to prevent hydration mismatch
        noOpSSRInlineScript: renderServerPlaceholder,
        adfStage: adfStage,
        document: finalDocument,
        appearance: appearance,
        contentMode: contentMode,
        stickyHeaders: stickyHeaders,
        extensionHandlers: mergedExtensionHandlers,
        eventHandlers: eventHandlers,
        featureFlags: editorFeatureFlags,
        dataProviders: mergedDataProviders.providerFactory,
        portal: portal,
        allowColumnSorting: true,
        allowHeadingAnchorLinks: allowHeadingAnchorLinks,
        allowAltTextOnImages: true,
        media: media,
        emojiResourceConfig: emojiResourceConfig,
        allowCopyToClipboard: true,
        allowWrapCodeBlock: true,
        ...rest,
        useSpecBasedValidator: true,
        truncated: isTruncatedContent,
        maxHeight: maxHeight,
        fadeOutHeight: fadeOutHeight,
        analyticsEventSeverityTracking: $1af8a83cb114ff50$export$3422b9c70e187e34,
        unsupportedContentLevelsTracking: $1af8a83cb114ff50$export$58eac04eb6213951(),
        allowPlaceholderText: allowPlaceholderText,
        allowCustomPanels: true,
        smartLinks: smartLinks,
        extensionViewportSizes: extensionViewportSizes,
        onError: errorHandler,
        UNSTABLE_allowTableAlignment: UNSTABLE_allowTableAlignment,
        UNSTABLE_allowTableResizing: UNSTABLE_allowTableResizing,
        UNSTABLE_isPresentational: UNSTABLE_isPresentational,
        allowRendererContainerStyles: allowRendererContainerStyles,
        shouldDisplayExtensionAsInline: (0, $0cc2e310acfcea5e$export$6eb9f199796a82af),
        ...nodeComponents && {
            nodeComponents: nodeComponents
        }
    }), renderWhenReady && renderWhenReady()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fgQGl.ContentRefetchHandler), {
        contentId: contentId,
        shouldRefetch: shouldRefetchContent
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj42z.FeedFollowErrorDisplay), {
        feedConfigError: feedFollowData.feedConfigError,
        mutationError: feedFollowData.mutationError,
        showErrorFlag: true
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        ...(0, $kLzei.getSmartCardRenderers)(),
        ...storeOptions,
        isAdminHubAIEnabled: isAdminHubAIEnabled,
        shouldControlDataExport: shouldControlDataExport,
        product: "CONFLUENCE"
    }, content);
});
module.exports["ANALYTICS_EVENT_SEVERITY_TRACKING"] = $1af8a83cb114ff50$export$3422b9c70e187e34;
module.exports["UNSUPPORTED_CONTENT_THRESHOLDS"] = $1af8a83cb114ff50$export$c02e908ea3c1fe52;
module.exports["ADFRendererComponent"] = $1af8a83cb114ff50$export$cec675c14d32c246;

});

parcelRegister("7VJPz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $a2xFu = parcelRequire("a2xFu");

var $kYvrE = parcelRequire("kYvrE");


var $aJPUt = parcelRequire("aJPUt");


var $5kjCz = parcelRequire("5kjCz");


var $4KFTW = parcelRequire("4KFTW");


var $au7xi = parcelRequire("au7xi");


var $jmjWc = parcelRequire("jmjWc");


const $16e92128cf9491a8$export$32d8d71ddecea49c = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "LmILK",
    name: "SmartButtonLoader",
    loader: async ()=>(await (parcelRequire("cMXyl"))).SmartButton
});


const $cd53535796fd282e$export$16ffa5f7b88dc45f = ({ contentId: contentId, contentType: contentType, cloudId: cloudId })=>{
    const extensionHandlers = {};
    extensionHandlers[0, $au7xi.smartButtonExtensionType] = (extension)=>{
        const pageAri = contentId ? (0, $a2xFu.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString() : undefined;
        const site = (0, $kYvrE.ConfluenceSiteAri).create({
            siteId: cloudId
        }).toString();
        const experienceName = (0, $5kjCz.getExperienceName)((0, $5kjCz.RENDERER), extension);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            contentId: contentId ?? '',
            mode: (0, $5kjCz.RENDERER),
            extensionKey: extension.extensionKey,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extension),
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $16e92128cf9491a8$export$32d8d71ddecea49c), {
            ruleId: extension.parameters?.ruleId,
            scopeId: extension.parameters?.scopeId,
            pageAri: pageAri,
            site: site,
            smartButtonName: extension.parameters?.smartButtonName,
            experienceTrackerName: experienceName,
            contentId: contentId ?? '',
            contentType: contentType ?? '',
            isViewMode: true
        }));
    };
    return extensionHandlers;
};
module.exports["getRendererSmartButtonExtensionHandlers"] = $cd53535796fd282e$export$16ffa5f7b88dc45f;

});

parcelRegister("au7xi", function(module, exports) {
const $ea41547e1b4f38b6$export$73185dbd06fc0dd8 = 'com.atlassian.automation.smart-button';
module.exports["smartButtonExtensionType"] = $ea41547e1b4f38b6$export$73185dbd06fc0dd8;

});

parcelRegister("cMXyl", function(module, exports) {

let $94f829b8ae30cb58$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $94f829b8ae30cb58$var$load("6wr18"),
    $94f829b8ae30cb58$var$load("gctwz"),
    $94f829b8ae30cb58$var$load("7f9Fz"),
    $94f829b8ae30cb58$var$load("ffEVr"),
    $94f829b8ae30cb58$var$load("lhkXg")
]).then(()=>parcelRequire('hLSQl'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("fgQGl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lpxTx = parcelRequire("lpxTx");

var $61vTv = parcelRequire("61vTv");


var $cLo2u = parcelRequire("cLo2u");


var $hp2SH = parcelRequire("hp2SH");


var $dPJCf = parcelRequire("dPJCf");


var $ep3mz = parcelRequire("ep3mz");

const $96596a053dd4ef1e$export$d1bbac313eb9a2c1 = ({ contentId: contentId, shouldRefetch: shouldRefetch, refetchImmediately: refetchImmediately, onRefetchComplete: onRefetchComplete })=>{
    const history = (0, $dPJCf.useHistory)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    (0, $42omo.useEffect)(()=>{
        let unlisten;
        if (shouldRefetch && contentId) {
            const chooseContentUnifiedQuery = contentType === 'blogpost' ? (0, $lpxTx.ContentBlogUnifiedQuery) : (0, $61vTv.ContentUnifiedQuery);
            const queryVariable = {
                contentId: contentId,
                spaceKey: spaceKey,
                useNewContentTopper: true
            };
            const refetchFn = async ()=>{
                let versionNumber;
                try {
                    // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
                    const queryResult = await (0, $hp2SH.getApolloClient)().query({
                        query: chooseContentUnifiedQuery,
                        context: {
                            single: true
                        },
                        fetchPolicy: 'network-only',
                        variables: queryVariable
                    });
                    // at this time, queryResult.data is always ContentUnifiedQueryType or ContentBlogUnifiedQueryType format
                    // @ts-ignore
                    versionNumber = queryResult.data.content?.nodes?.[0]?.version?.number;
                } catch  {
                // NOTE: We intentionally swallow any possible error here as this query is only aimed to
                // populate the cache with just published content. Should any error occur here after
                // successful publishing the page, the Apollo cache for the query will be invalidated
                // anyway and View Page will fetch the page and handle possible errors.
                }
                // If a callback is supplied, call it regardless
                onRefetchComplete && onRefetchComplete(versionNumber);
            };
            if (refetchImmediately) refetchFn();
            else unlisten = history?.listen(refetchFn);
        }
        return ()=>{
            // Call the unlistener when this component unmounts
            unlisten && unlisten();
        };
    /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [
        shouldRefetch
    ]);
    return null;
};
module.exports["ContentRefetchHandler"] = $96596a053dd4ef1e$export$d1bbac313eb9a2c1;

});

parcelRegister("cNwLI", function(module, exports) {
const $b692efbc19ac9594$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $b692efbc19ac9594$export$df3c2062a081a534 = 'com.atlassian.confluence.spotlight';
const $b692efbc19ac9594$export$4454075c4322ae47 = 'com.atlassian.confluence.hub-section';
const $b692efbc19ac9594$export$2dd5fc71941a6787 = 'com.atlassian.confluence.knowledge-cards';
const $b692efbc19ac9594$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $b692efbc19ac9594$export$514105ca7c79025d = 'com.atlassian.confluence.carousel';
const $b692efbc19ac9594$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $b692efbc19ac9594$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $b692efbc19ac9594$export$8e1a1e8b8109dbf3 = '#DDDEE1';
const $b692efbc19ac9594$export$8161b1f4e2928fa0 = '--hub-primary-color';
const $b692efbc19ac9594$export$94d2a2331edd895d = '--hub-primary-text-color';
const $b692efbc19ac9594$export$64de52c9db8240f6 = '--hub-primary-link-color';
const $b692efbc19ac9594$export$4c91e7265b76e3a1 = '32px';
const $b692efbc19ac9594$export$d713f99e5e84a256 = '40px'; // Pre-standardization height for CSM fallback
const $b692efbc19ac9594$export$6faa4a850bc4d0ce = 'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
const $b692efbc19ac9594$export$ea77880e3935182d = 'unknown';
const $b692efbc19ac9594$export$c7f012c6e67c4217 = 0;
module.exports["CARDS_EXTENSION_TYPE"] = $b692efbc19ac9594$export$81e5b59a1e176638;
module.exports["SPOTLIGHT_EXTENSION_TYPE"] = $b692efbc19ac9594$export$df3c2062a081a534;
module.exports["SECTION_EXTENSION_TYPE"] = $b692efbc19ac9594$export$4454075c4322ae47;
module.exports["RESOURCE_TILES_EXTENSION_TYPE"] = $b692efbc19ac9594$export$2dd5fc71941a6787;
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $b692efbc19ac9594$export$9fdf64a495514b4;
module.exports["CAROUSEL_EXTENSION_TYPE"] = $b692efbc19ac9594$export$514105ca7c79025d;
module.exports["SEARCH_EXTENSION_TYPE"] = $b692efbc19ac9594$export$cb2d1b0c753e69e6;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $b692efbc19ac9594$export$c14e692c91462ed4;
module.exports["DEFAULT_BRANDING_COLOR"] = $b692efbc19ac9594$export$8e1a1e8b8109dbf3;
module.exports["HUB_PRIMARY_COLOR_CSS_VAR"] = $b692efbc19ac9594$export$8161b1f4e2928fa0;
module.exports["HUB_PRIMARY_TEXT_COLOR_CSS_VAR"] = $b692efbc19ac9594$export$94d2a2331edd895d;

});

parcelRegister("kcoxM", function(module, exports) {
const $b61d5307562de512$export$81e5b59a1e176638 = 'com.atlassian.confluence.link-cards';
const $b61d5307562de512$export$8a4891a61ff91b00 = 'cards';
const $b61d5307562de512$export$67bfcae6d68bb0bf = 'cardsExtension';
const $b61d5307562de512$export$7f17fab0aecb44ed = 'cardsExtensionConfig';
const $b61d5307562de512$export$6a35a50674becbae = 'cardsExtensionConfigBackgroundColor';
const $b61d5307562de512$export$9bf56665bf6ea6ed = 'cardsExtensionConfigBorderColor';
const $b61d5307562de512$export$cf23b6d2fd159502 = 'cardsExtensionConfigTextColor';
const $b61d5307562de512$export$131b76b4d30d2b44 = '2';
const $b61d5307562de512$export$a08b7507bedba276 = '3';
const $b61d5307562de512$export$c87753a8bb0c4e75 = '4';
const $b61d5307562de512$export$b84f9a7c097c895c = '5';
const $b61d5307562de512$export$5e905747d7497a1f = [
    {
        src: 'https://images.unsplash.com/photo-1571327352610-1c5484ccc840?auto=format&fit=crop&q=80&w=450',
        alt: 'closed wooden window'
    },
    {
        src: 'https://images.unsplash.com/photo-1566486106118-e1c24ad08802?auto=format&fit=crop&q=80&w=450',
        alt: 'green coconut trees'
    },
    {
        src: 'https://images.unsplash.com/photo-1602021224139-a6ba7e601732?auto=format&fit=crop&q=80&w=450',
        alt: 'white and black striped chair'
    },
    {
        src: 'https://images.unsplash.com/photo-1722259038071-6082eaf397ff?auto=format&fit=crop&q=80&w=450',
        alt: 'surfboard on top of a cement wall'
    },
    {
        src: 'https://images.unsplash.com/photo-1555001356-333dbc0f8b48?auto=format&fit=crop&q=80&w=450',
        alt: 'white stairs'
    },
    {
        src: 'https://images.unsplash.com/photo-1680258551363-6b5fd1ac2048?auto=format&fit=crop&q=80&w=450',
        alt: 'swimming pool tiles'
    }
];
module.exports["CARDS_EXTENSION_TYPE"] = $b61d5307562de512$export$81e5b59a1e176638;
module.exports["CARDS_EXTENSION_KEY"] = $b61d5307562de512$export$8a4891a61ff91b00;
module.exports["CARDS_EXTENSION_ANALYTIC_SOURCE"] = $b61d5307562de512$export$67bfcae6d68bb0bf;
module.exports["CARDS_EXTENSION_CONFIG_ANALYTIC_SOURCE"] = $b61d5307562de512$export$7f17fab0aecb44ed;
module.exports["CARDS_EXTENSION_CONFIG_BACKGROUND_ANALYTIC_SOURCE"] = $b61d5307562de512$export$6a35a50674becbae;
module.exports["CARDS_EXTENSION_CONFIG_BORDER_ANALYTIC_SOURCE"] = $b61d5307562de512$export$9bf56665bf6ea6ed;
module.exports["CARDS_EXTENSION_CONFIG_TEXT_ANALYTIC_SOURCE"] = $b61d5307562de512$export$cf23b6d2fd159502;
module.exports["CARDS_EXTENSION_VERSION_2"] = $b61d5307562de512$export$131b76b4d30d2b44;
module.exports["CARDS_EXTENSION_VERSION_3"] = $b61d5307562de512$export$a08b7507bedba276;
module.exports["CARDS_EXTENSION_VERSION_4"] = $b61d5307562de512$export$c87753a8bb0c4e75;
module.exports["CARDS_EXTENSION_VERSION_5"] = $b61d5307562de512$export$b84f9a7c097c895c;
module.exports["CARDS_IMAGES_V5"] = $b61d5307562de512$export$5e905747d7497a1f;

});

parcelRegister("lf1vG", function(module, exports) {
const $5c1067f237374bc4$export$e03f5e560317f88a = '1';
const $5c1067f237374bc4$export$5e16975fb5214c6c = 'company-hub-search';
const $5c1067f237374bc4$export$cb2d1b0c753e69e6 = 'com.atlassian.confluence.company-hub-search';
const $5c1067f237374bc4$export$ec7b7d5be35b7dd3 = 'customSearchExtension';
module.exports["SEARCH_EXTENSION_VERSION_1"] = $5c1067f237374bc4$export$e03f5e560317f88a;
module.exports["SEARCH_EXTENSION_KEY"] = $5c1067f237374bc4$export$5e16975fb5214c6c;
module.exports["SEARCH_EXTENSION_TYPE"] = $5c1067f237374bc4$export$cb2d1b0c753e69e6;
module.exports["CUSTOM_SEARCH_EXTENSION_ANALYTIC_SOURCE"] = $5c1067f237374bc4$export$ec7b7d5be35b7dd3;

});

parcelRegister("cVaAA", function(module, exports) {
const $8fff034c75eb58ab$export$9fdf64a495514b4 = 'com.atlassian.confluence.links-menu';
const $8fff034c75eb58ab$export$ed5854f17099adbf = 'linksMenuExtension';
module.exports["LINKS_MENU_EXTENSION_TYPE"] = $8fff034c75eb58ab$export$9fdf64a495514b4;
module.exports["LINKS_MENU_EXTENSION_ANALYTIC_SOURCE"] = $8fff034c75eb58ab$export$ed5854f17099adbf;

});

parcelRegister("5Ac5G", function(module, exports) {
const $df94cb31de3cc11e$export$a06ac4f1777262dc = 'com.atlassian.confluence.carousel';
const $df94cb31de3cc11e$export$6c8179fa243b4399 = 'carousel';
const $df94cb31de3cc11e$export$ca14f22a239c4ae9 = 'carouselExtension';
const $df94cb31de3cc11e$export$4cb671946a80c52e = 'carouselExtensionConfig';
const $df94cb31de3cc11e$export$93995a2609cff38d = 8;
const $df94cb31de3cc11e$export$3a86d0fc7eb402f4 = 'carousel-navigation-frame-';
const $df94cb31de3cc11e$export$9575b4f5d97a1c29 = '1';
const $df94cb31de3cc11e$export$b429752dfe934bea = '2';
const $df94cb31de3cc11e$export$c5c6e75ceae0cc22 = 10;
module.exports["carouselExtensionType"] = $df94cb31de3cc11e$export$a06ac4f1777262dc;
module.exports["carouselExtensionKey"] = $df94cb31de3cc11e$export$6c8179fa243b4399;
module.exports["carouselContentAnalyticSource"] = $df94cb31de3cc11e$export$ca14f22a239c4ae9;
module.exports["carouselConfigAnalyticSource"] = $df94cb31de3cc11e$export$4cb671946a80c52e;
module.exports["AUTOPLAY_SECONDS"] = $df94cb31de3cc11e$export$93995a2609cff38d;
module.exports["ARIA_CONTROLS_PREFIX"] = $df94cb31de3cc11e$export$3a86d0fc7eb402f4;
module.exports["CAROUSEL_VERSION_2"] = $df94cb31de3cc11e$export$b429752dfe934bea;
module.exports["FRAMES_LIMIT_V2"] = $df94cb31de3cc11e$export$c5c6e75ceae0cc22;

});

parcelRegister("bl1ay", function(module, exports) {
const $41fb1ea7d1d28d85$export$c14e692c91462ed4 = 'com.atlassian.confluence.hub-element-placeholder';
const $41fb1ea7d1d28d85$export$ca3a94184e0fbd97 = 'hub-element-placeholder';
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE"] = $41fb1ea7d1d28d85$export$c14e692c91462ed4;
module.exports["HUB_ELEMENT_PLACEHOLDER_EXTENSION_KEY"] = $41fb1ea7d1d28d85$export$ca3a94184e0fbd97;

});

parcelRegister("cbvYp", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fOKpq = parcelRequire("fOKpq");


var $4IoVL = parcelRequire("4IoVL");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $1NBp8 = parcelRequire("1NBp8");


var $6M71K = parcelRequire("6M71K");


var $5kjCz = parcelRequire("5kjCz");


var $hUS75 = parcelRequire("hUS75");


var $4KFTW = parcelRequire("4KFTW");


var $bX5uj = parcelRequire("bX5uj");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $aJPUt = parcelRequire("aJPUt");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $lOeVN = parcelRequire("lOeVN");


var $bAIqi = parcelRequire("bAIqi");


var $bflGB = parcelRequire("bflGB");



var $hl1Kw = parcelRequire("hl1Kw");


var $cEgMD = parcelRequire("cEgMD");


var $78QFu = parcelRequire("78QFu");


var $ep3mz = parcelRequire("ep3mz");


var $2YtTU = parcelRequire("2YtTU");





var $inPa6 = parcelRequire("inPa6");


var $k00oi = parcelRequire("k00oi");


var $5Gcps = parcelRequire("5Gcps");





var $7QM6o = parcelRequire("7QM6o");










const $4305591bcf0ed0e4$export$bd1b893a71ee8dab = (link)=>{
    const [analyticFields, setAnalyticFields] = (0, $42omo.useState)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const fetchData = async ()=>{
            const client = new (0, $k00oi.default)();
            try {
                const queriedMetadata = !!link && await client.fetchData(link);
                if (!queriedMetadata || !queriedMetadata.meta) return;
                const { containerId: initialContainerId, tenantId: initialTenantId, objectId: initialObjectId } = queriedMetadata.meta || {};
                if (!initialObjectId) return;
                const newObjectId = await (0, $5Gcps.getClickAndViewEventObjectIdFromLinkData)(initialObjectId, initialContainerId);
                setAnalyticFields({
                    containerId: initialContainerId,
                    tenantId: initialTenantId,
                    objectId: newObjectId
                });
            } catch (error) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).COMPANY_HUB
                });
                (0, $7Sm4c.markErrorAsHandled)(error);
            }
        };
        fetchData();
    }, [
        link
    ]);
    const { tenantId: tenantId, objectId: objectId } = analyticFields || {};
    const handleClick = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateClickEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    const handleView = ()=>{
        if (tenantId === cloudId) createAnalyticsEvent?.((0, $5Gcps.generateViewEventPayload)(activationId, cloudId, objectId, spaceId)).fire();
    };
    return {
        handleClick: analyticFields ? handleClick : undefined,
        handleView: analyticFields ? handleView : undefined
    };
};



var $biMIt = parcelRequire("biMIt");





var $xQxzY = parcelRequire("xQxzY");


var $eSUdr = parcelRequire("eSUdr");





var $1uFM6 = parcelRequire("1uFM6");




const $a453bfc5db2076e7$export$df3f3e4ed2d81d7 = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds })=>{
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming -- Experimental Schema GraphQL Operation
    (0, $eSUdr.default)`query SegmentationTargetGroupsFieldGroupsQuery($after:String$first:Int=25){groups(after:$after first:$first){nodes{id name}pageInfo{endCursor hasNextPage}}}`, {
        variables: {
            after: nextCursor
        },
        skip: initialGroupIds.length === 0
    });
    let errorComponent = undefined;
    if (error && !loading) {
        if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        else errorComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
    }
    return {
        data: data,
        loading: loading,
        errorComponent: errorComponent
    };
};


const $73ff39965b133879$var$useFeedbackCollectorWrapper = ({ source: source, type: type })=>{
    return (0, $lOeVN.useFeedbackCollector)({
        source: source,
        type: type
    });
};
const $73ff39965b133879$var$useSegmentationTargetGroupsWrapper = ({ nextCursor: nextCursor, initialGroupIds: initialGroupIds = [] })=>{
    return (0, $a453bfc5db2076e7$export$df3f3e4ed2d81d7)({
        nextCursor: nextCursor,
        initialGroupIds: initialGroupIds
    });
};
const $73ff39965b133879$var$ShortcutListenerWrapper = ({ accelerator: accelerator, listener: listener })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bflGB.ShortcutListener), {
        accelerator: accelerator,
        listener: listener
    });
};
const $73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper = ({ feature: feature })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bAIqi.ExtensionConfigUpsellLoader), {
        feature: feature
    });
};
const $73ff39965b133879$var$submitError = (error)=>{
    (0, $5ZqQS.getMonitoringClient)().submitError(error, {
        attribution: (0, $3IBnw.Attribution).COMPANY_HUB
    });
    (0, $7Sm4c.markErrorAsHandled)(error);
};
const $73ff39965b133879$var$SmartCardProvider = ({ children: children })=>{
    return(// disable preview panel functionality for cards
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6M71K.ConfluenceSmartCardProvider), {
        isPreviewPanelAvailable: (_ari)=>false
    }, children));
};
const $73ff39965b133879$export$52286abe2bf4f236 = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $42omo.useCallback)(({ analyticsSource: analyticsSource })=>{
        experienceTracker.start({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            attributes: {
                source: analyticsSource
            }
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $42omo.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.CARDS_IMAGE_UPLOAD_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$50a2d523eb80eb6f = ()=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const start = (0, $42omo.useCallback)(({ analyticsSource: analyticsSource, confluencePageId: confluencePageId })=>{
        experienceTracker.start({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            attributes: {
                source: analyticsSource,
                contentId: confluencePageId
            }
        });
    }, [
        experienceTracker
    ]);
    const abort = (0, $42omo.useCallback)(({ reason: reason })=>{
        experienceTracker.abort({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            reason: reason
        });
    }, [
        experienceTracker
    ]);
    const succeed = (0, $42omo.useCallback)(()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE)
        });
    }, [
        experienceTracker
    ]);
    const stopOnError = (0, $42omo.useCallback)(({ error: error })=>{
        experienceTracker.stopOnError({
            name: (0, $irVI7.COMPANY_HUB_CARD_AI_DESCRIPTION_EXPERIENCE),
            error: error
        });
    }, [
        experienceTracker
    ]);
    return {
        start: start,
        abort: abort,
        succeed: succeed,
        stopOnError: stopOnError
    };
};
const $73ff39965b133879$export$4bd687f80e42155a = (activeContentId, maybeCustomCoverImage)=>{
    if (maybeCustomCoverImage.indexOf('/') !== -1) {
        const temp = maybeCustomCoverImage.split('/');
        return [
            temp[0],
            temp[1]
        ];
    }
    // If it's not a stored cover image, we return original contentId & imageSrc
    return [
        activeContentId,
        maybeCustomCoverImage
    ];
};
const $73ff39965b133879$export$7f746b47c356effa = ({ contentId: contentId, imageSrc: imageSrc })=>{
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    // When imageSrc is a stored cover image, it comes in format '{contentId}/{fileId}'
    // We need to split the string to get the collectionId and fileId
    const [collectionId, fileId] = $73ff39965b133879$export$4bd687f80e42155a(contentId, imageSrc);
    (0, $42omo.useEffect)(()=>{
        async function createMediaConfig() {
            if (!(0, $4IoVL.createRendererMediaProvider)) return;
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: collectionId,
                isExternalShare: false
            });
            if (!viewMediaClientConfig) {
                setMediaConfig(null);
                return;
            }
            setMediaConfig({
                collection: `contentId-${collectionId}`,
                authProvider: viewMediaClientConfig.authProvider,
                fileId: fileId
            });
        }
        createMediaConfig();
    }, [
        collectionId,
        fileId
    ]);
    return mediaConfig;
};
const $73ff39965b133879$export$9a7b37d3055a69a6 = ({ mode: mode, extensionNode: extensionNode, contentId: contentId = '', children: children })=>{
    const mediaUploadExperienceTracker = $73ff39965b133879$export$52286abe2bf4f236();
    const aiDescriptionExperienceTracker = $73ff39965b133879$export$50a2d523eb80eb6f();
    const sessionData = (0, $bQm3c.useSessionData)();
    const { cloudId: cloudId, displayName: displayName, isAdminHubAIEnabled: isAdminHubAIEnabled, orgId: orgId, userId: userId } = sessionData || {};
    const [{ searchSessionId: searchSessionId }] = (0, $hl1Kw.useSearchSessionId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isTargetAudience: isTargetAudience } = (0, $42omo.useContext)((0, $biMIt.AudienceSegmentationContext));
    const shouldShowPremiumUpsell = (0, $2YtTU.usePremiumGate)();
    const ConfigUpsellScreen = (0, $42omo.useMemo)(()=>shouldShowPremiumUpsell ? ({ feature: feature })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73ff39965b133879$var$ExtensionConfigUpsellLoaderWrapper, {
                feature: feature
            }) : undefined, [
        shouldShowPremiumUpsell
    ]);
    const experienceStartComponent = (0, $42omo.useCallback)(()=>{
        if (!extensionNode) return null;
        const macroAttributes = (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode);
        const experienceName = (0, $5kjCz.getExperienceName)(mode, extensionNode);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KFTW.MacroExperienceStart), {
            name: experienceName,
            attributes: macroAttributes,
            extensionKey: extensionNode.extensionKey,
            contentId: contentId,
            mode: mode,
            timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceSuccessComponent = (0, $42omo.useCallback)(()=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bX5uj.MacroExperienceSuccess), {
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        extensionNode,
        contentId,
        mode
    ]);
    const experienceStopComponent = (0, $42omo.useCallback)(({ error: error })=>{
        if (!extensionNode) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hUS75.MacroExperienceStop), {
            error: error,
            name: (0, $5kjCz.getExperienceName)(mode, extensionNode),
            contentId: contentId,
            extensionKey: extensionNode.extensionKey,
            mode: mode,
            attributes: (0, $5kjCz.getMacroAttributesFromADFNode)(extensionNode)
        });
    }, [
        mode,
        extensionNode,
        contentId
    ]);
    const isSSRProductInDarkMode = (0, $42omo.useMemo)(()=>{
        return undefined;
    }, []);
    const errorBoundaryComponent = (0, $42omo.useMemo)(()=>({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).COMPANY_HUB
            }, children), []);
    const errorDisplayComponent = (0, $42omo.useMemo)(()=>({ error: error, childrenComponents: childrenComponents })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            }, childrenComponents), []);
    const useAnalyticsActions = (0, $42omo.useMemo)(()=>({
            useLinkAnalyticActions: $4305591bcf0ed0e4$export$bd1b893a71ee8dab
        }), []);
    const value = (0, $42omo.useMemo)(()=>({
            experienceStartComponent: experienceStartComponent,
            experienceSuccessComponent: experienceSuccessComponent,
            experienceStopComponent: experienceStopComponent,
            cloudId: cloudId,
            searchConfigProvider: {
                peopleDirectoryUrl: (0, $1NBp8.PEOPLE_DIRECTORY).toUrl(),
                advancedSearchUrl: (0, $1NBp8.ADVANCED_SEARCH).toUrl(),
                searchSessionId: searchSessionId || ''
            },
            displayName: displayName || '',
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            orgId: orgId || '',
            userId: userId || '',
            errorBoundaryComponent: errorBoundaryComponent,
            errorDisplayComponent: errorDisplayComponent,
            submitError: $73ff39965b133879$var$submitError,
            markErrorAsHandled: $7Sm4c.markErrorAsHandled,
            useMediaConfig: $73ff39965b133879$export$7f746b47c356effa,
            createEditorMediaProvider: $4IoVL.createEditorMediaProvider,
            mediaUploadExperienceTracker: mediaUploadExperienceTracker,
            aiDescriptionExperienceTracker: aiDescriptionExperienceTracker,
            useFeedbackCollector: $73ff39965b133879$var$useFeedbackCollectorWrapper,
            shortcutListener: $73ff39965b133879$var$ShortcutListenerWrapper,
            shouldShowPremiumUpsell: shouldShowPremiumUpsell,
            ConfigUpsellScreen: ConfigUpsellScreen,
            useSegmentationTargetGroups: $73ff39965b133879$var$useSegmentationTargetGroupsWrapper,
            isSSRProductInDarkMode: isSSRProductInDarkMode,
            analyticsContext: {
                pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
            },
            useAnalyticsActions: useAnalyticsActions,
            isCompanyHub: (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey),
            isTargetAudience: isTargetAudience,
            smartCardProviderComponent: $73ff39965b133879$var$SmartCardProvider,
            showConfigPreambleSupportLink: true,
            enableTargeting: true,
            enableUnifiedSearchFeatures: true,
            enableSmartCardsFields: true
        }), [
        experienceSuccessComponent,
        experienceStopComponent,
        cloudId,
        displayName,
        isAdminHubAIEnabled,
        orgId,
        userId,
        searchSessionId,
        shouldShowPremiumUpsell,
        ConfigUpsellScreen,
        isSSRProductInDarkMode,
        errorBoundaryComponent,
        errorDisplayComponent,
        experienceStartComponent,
        mediaUploadExperienceTracker,
        aiDescriptionExperienceTracker,
        useAnalyticsActions,
        spaceKey,
        isTargetAudience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fOKpq.ProductDependenciesContext).Provider, {
        value: value
    }, children);
};
const $73ff39965b133879$export$443fd6903ad182a1 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($73ff39965b133879$export$9a7b37d3055a69a6, props, children);
module.exports["ConfluenceDependenciesProvider"] = $73ff39965b133879$export$443fd6903ad182a1;

});

parcelRegister("hUS75", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source) {
    if ((0, $6fil2.containsNetworkError)(error)) {
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).abort({
            name: name,
            reason: `Aborted ${name} because of network error: ${error.toString()}`,
            checkForTimeout: false,
            attributes: {
                ...attributes,
                source: source
            }
        });
        return;
    }
    (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).fail({
        name: name,
        error: error,
        attributes: {
            ...attributes,
            source: source
        }
    });
}
function $50ff55d614a641f6$export$d22b49804594ed4d({ attributes: attributes, children: children = null, error: error, contentId: contentId, mode: mode, name: name, source: source }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        if (error) $50ff55d614a641f6$export$720dc4209419df4e(name, error, mode, contentId, attributes, source);
        else (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        error,
        mode,
        name,
        source
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceStop"] = $50ff55d614a641f6$export$d22b49804594ed4d;

});

parcelRegister("bAIqi", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c1c72132c26b9ae6$export$349c99e57ed161b9 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "at4mJ",
    name: "ExtensionConfigUpsellLoader",
    loader: async ()=>(await (parcelRequire("dGKR7"))).ExtensionConfigUpsell
});

const $c1c72132c26b9ae6$export$25389a114c9b393f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "rxN2C",
    name: "ExtensionInsertUpsellLoader",
    loader: async ()=>(await (parcelRequire("4QMuc"))).ExtensionInsertUpsell
});
module.exports["ExtensionConfigUpsellLoader"] = $c1c72132c26b9ae6$export$349c99e57ed161b9;
module.exports["ExtensionInsertUpsellLoader"] = $c1c72132c26b9ae6$export$25389a114c9b393f;

});

parcelRegister("dGKR7", function(module, exports) {

let $9f738b302c323512$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f738b302c323512$var$load("fD0v8"),
    $9f738b302c323512$var$load("6XCf4"),
    $9f738b302c323512$var$load("1qlDN"),
    $9f738b302c323512$var$load("1yVM6"),
    $9f738b302c323512$var$load("5pvpJ"),
    $9f738b302c323512$var$load("9wTrW")
]).then(()=>parcelRequire('d1uaq'));

});

parcelRegister("4QMuc", function(module, exports) {

let $3881a11aabef5433$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3881a11aabef5433$var$load("fD0v8"),
    $3881a11aabef5433$var$load("6XCf4"),
    $3881a11aabef5433$var$load("1qlDN"),
    $3881a11aabef5433$var$load("1yVM6"),
    $3881a11aabef5433$var$load("5pvpJ"),
    $3881a11aabef5433$var$load("5HTv6")
]).then(()=>parcelRequire('f4NfX'));

});

parcelRegister("2YtTU", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $j1Ss3 = parcelRequire("j1Ss3");


var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $5ZqQS = parcelRequire("5ZqQS");

const $50d2dd6da149924b$export$31a131ac01af5546 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const canSkipEntitlementCheck = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { data: data, error: error } = (0, $j1Ss3.useQuery)((0, $eSUdr.default)`query usePremiumGatePremiumGateQuery{entitlements{premiumExtensions{isEntitled}}}`, {
        skip: canSkipEntitlementCheck
    });
    if (error) {
        if (!((0, $1uFM6.isUnauthorizedError)(error) || (0, $f9jv7.isNotFoundError)(error))) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).COMPANY_HUB
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
    }
    return !canSkipEntitlementCheck && !data?.entitlements.premiumExtensions.isEntitled;
};
module.exports["usePremiumGate"] = $50d2dd6da149924b$export$31a131ac01af5546;

});

parcelRegister("5Gcps", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $eSUdr = parcelRequire("eSUdr");

const $e798eb82c10075ec$export$10df301dbc20c6db = (0, $eSUdr.default)`query SpaceMetadataQuery($id:Long!){spaces(spaceId:$id){nodes{homepage{id}}}}`;


const $9f3924c176ad2a57$export$2dd23eaa621322c4 = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'viewed',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: 'page',
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: 'page',
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$e25d369331b443dc = (activationId, cloudId, objectId, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'clicked',
            actionSubject: 'companyHubLink',
            source: 'companyHub',
            objectType: objectId ? 'page' : null,
            objectId: objectId,
            attributes: {
                activationId: activationId,
                spaceId: spaceId,
                spaceType: 'system',
                pageType: objectId ? 'page' : null,
                cloudId: cloudId
            }
        }
    });
const $9f3924c176ad2a57$export$95c55278d4aca494 = async (objectId, destinationContainerId)=>{
    if (destinationContainerId === objectId) {
        const client = (0, $hp2SH.getApolloClient)();
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const { data: data } = await client.query({
            query: (0, $e798eb82c10075ec$export$10df301dbc20c6db),
            variables: {
                id: destinationContainerId
            }
        });
        const homepageId = data?.spaces?.nodes?.[0]?.homepage?.id;
        if (!homepageId) return;
        return homepageId;
    }
    return objectId;
};
module.exports["generateViewEventPayload"] = $9f3924c176ad2a57$export$2dd23eaa621322c4;
module.exports["generateClickEventPayload"] = $9f3924c176ad2a57$export$e25d369331b443dc;
module.exports["getClickAndViewEventObjectIdFromLinkData"] = $9f3924c176ad2a57$export$95c55278d4aca494;

});

parcelRegister("biMIt", function(module, exports) {

var $jtfsl = parcelRequire("jtfsl");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $1uFM6 = parcelRequire("1uFM6");


var $7Sm4c = parcelRequire("7Sm4c");


var $jMyy4 = parcelRequire("jMyy4");

const $ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery = (0, $jtfsl.default);
const $ab43be195aa7029f$export$f8421e3bf566787d = 'accessible-to-anyone';
const $ab43be195aa7029f$export$6fb8438eed1d64ed = /*#__PURE__*/ (0, $42omo.createContext)({
    isCompanyHub: false,
    currentAudienceGroupIds: [],
    setCurrentAudienceGroupIds: ()=>{},
    isTargetAudience: ()=>true,
    isSegmentationApplied: false,
    setIsSegmentationApplied: ()=>{}
});
const $ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal = ({ children: children, isCompanyHub: isCompanyHub, initialAudienceGroupIds: initialAudienceGroupIds = [], initialSegmentationApplied: initialSegmentationApplied = false, shouldFetchUserGroups: shouldFetchUserGroups = false })=>{
    const [currentAudienceGroupIds, setCurrentAudienceGroupIds] = (0, $42omo.useState)(initialAudienceGroupIds);
    const [isSegmentationApplied, setIsSegmentationApplied] = (0, $42omo.useState)(initialSegmentationApplied);
    const isTargetAudience = (0, $42omo.useCallback)((targetGroupIds)=>{
        if (!isCompanyHub || // if we are outside of company hub, no filtering
        targetGroupIds === undefined // if no target groups are provided, no filtering
        ) return true;
        setIsSegmentationApplied(true);
        const audienceGroupIdsSet = new Set(currentAudienceGroupIds);
        if (audienceGroupIdsSet.has($ab43be195aa7029f$export$f8421e3bf566787d)) return false;
        return targetGroupIds?.some((allowedGroup)=>audienceGroupIdsSet.has(allowedGroup));
    }, [
        currentAudienceGroupIds,
        isCompanyHub
    ]);
    const audienceSegmentationContextValue = (0, $42omo.useMemo)(()=>({
            currentAudienceGroupIds: currentAudienceGroupIds,
            setCurrentAudienceGroupIds: setCurrentAudienceGroupIds,
            isCompanyHub: isCompanyHub,
            isTargetAudience: isTargetAudience,
            isSegmentationApplied: isSegmentationApplied,
            setIsSegmentationApplied: setIsSegmentationApplied
        }), [
        currentAudienceGroupIds,
        isCompanyHub,
        isTargetAudience,
        isSegmentationApplied
    ]);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { error: queryError, loading: queryLoading } = (0, $jMyy4.useQueryInterop)($ab43be195aa7029f$var$AudienceSegmentationContextProviderQuery, {
        skip: !shouldFetchUserGroups || !isCompanyHub,
        variables: {
            accountId: userId
        },
        onCompleted: (data)=>{
            const userGroupIds = data?.user?.confluence?.groupsWithId?.map((result)=>result?.id).filter((id)=>!!id) ?? [];
            // onCompleted shouldn't be called if we skip the query but this is to ensure
            // the state doesn't get set when the fixture mock gives this query the default value
            shouldFetchUserGroups && setCurrentAudienceGroupIds(userGroupIds);
        }
    });
    const errorDisplay = (0, $42omo.useMemo)(()=>{
        if (queryError && !queryLoading) {
            if ((0, $1uFM6.isUnauthorizedError)(queryError)) (0, $7Sm4c.markErrorAsHandled)(queryError);
            else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: queryError
            });
        }
        return null;
    }, [
        queryError,
        queryLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ab43be195aa7029f$export$6fb8438eed1d64ed.Provider, {
        value: audienceSegmentationContextValue
    }, errorDisplay, children);
};
const $ab43be195aa7029f$export$23b23ee9c5e80f4e = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).COMPANY_HUB
})($ab43be195aa7029f$var$AudienceSegmentationContextProviderInternal);
module.exports["COMMON_VIEW_ID"] = $ab43be195aa7029f$export$f8421e3bf566787d;
module.exports["AudienceSegmentationContext"] = $ab43be195aa7029f$export$6fb8438eed1d64ed;
module.exports["AudienceSegmentationContextProvider"] = $ab43be195aa7029f$export$23b23ee9c5e80f4e;

});

parcelRegister("6iyAr", function(module, exports) {

let $495f40b734d5c4c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $495f40b734d5c4c5$var$load("9w0Re"),
    $495f40b734d5c4c5$var$load("1wQU1"),
    $495f40b734d5c4c5$var$load("cB5rV"),
    $495f40b734d5c4c5$var$load("aKnnM"),
    $495f40b734d5c4c5$var$load("kAAjo"),
    $495f40b734d5c4c5$var$load("fbRdC"),
    $495f40b734d5c4c5$var$load("2YffH"),
    $495f40b734d5c4c5$var$load("f35QR"),
    $495f40b734d5c4c5$var$load("eVYW1"),
    $495f40b734d5c4c5$var$load("ls0Um"),
    $495f40b734d5c4c5$var$load("020xd"),
    $495f40b734d5c4c5$var$load("eTBsW"),
    $495f40b734d5c4c5$var$load("6HBYC"),
    $495f40b734d5c4c5$var$load("1oiJ6"),
    $495f40b734d5c4c5$var$load("huUvS"),
    $495f40b734d5c4c5$var$load("1wZEW"),
    $495f40b734d5c4c5$var$load("98UJI"),
    $495f40b734d5c4c5$var$load("hwLGf"),
    $495f40b734d5c4c5$var$load("2B6wT"),
    $495f40b734d5c4c5$var$load("gKYwM"),
    $495f40b734d5c4c5$var$load("a5wu4"),
    $495f40b734d5c4c5$var$load("b0cmi"),
    $495f40b734d5c4c5$var$load("51haJ"),
    $495f40b734d5c4c5$var$load("lPQcc"),
    $495f40b734d5c4c5$var$load("8VT23"),
    $495f40b734d5c4c5$var$load("jg5LT"),
    $495f40b734d5c4c5$var$load("7f9Fz"),
    $495f40b734d5c4c5$var$load("9XYQ9"),
    $495f40b734d5c4c5$var$load("ht6hk"),
    $495f40b734d5c4c5$var$load("9ijrN"),
    $495f40b734d5c4c5$var$load("aeEUI"),
    $495f40b734d5c4c5$var$load("lUQAm"),
    $495f40b734d5c4c5$var$load("eY3St"),
    $495f40b734d5c4c5$var$load("bkd4T"),
    $495f40b734d5c4c5$var$load("hhss7"),
    $495f40b734d5c4c5$var$load("7EorR"),
    $495f40b734d5c4c5$var$load("awqCy"),
    $495f40b734d5c4c5$var$load("cMlHc"),
    $495f40b734d5c4c5$var$load("8KWDC"),
    $495f40b734d5c4c5$var$load("bTmOC"),
    $495f40b734d5c4c5$var$load("jTaSF"),
    $495f40b734d5c4c5$var$load("9YBgR"),
    $495f40b734d5c4c5$var$load("7ZIlR"),
    $495f40b734d5c4c5$var$load("8fXIr"),
    $495f40b734d5c4c5$var$load("dVkhd"),
    $495f40b734d5c4c5$var$load("dTsOE"),
    $495f40b734d5c4c5$var$load("7jSfd"),
    $495f40b734d5c4c5$var$load("4HZlX"),
    $495f40b734d5c4c5$var$load("kDqHr"),
    $495f40b734d5c4c5$var$load("6wr18"),
    $495f40b734d5c4c5$var$load("kjZZD"),
    $495f40b734d5c4c5$var$load("9ZAzg"),
    $495f40b734d5c4c5$var$load("kJSYP"),
    $495f40b734d5c4c5$var$load("3gJkK"),
    $495f40b734d5c4c5$var$load("6nDfv"),
    $495f40b734d5c4c5$var$load("Wowvf"),
    $495f40b734d5c4c5$var$load("ffEVr"),
    $495f40b734d5c4c5$var$load("fMsyQ")
]).then(()=>parcelRequire('kWs4M'));

});

parcelRegister("9YRbs", function(module, exports) {

let $7442f8d5a8ec79a0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7442f8d5a8ec79a0$var$load("hwLGf"),
    $7442f8d5a8ec79a0$var$load("9w0Re"),
    $7442f8d5a8ec79a0$var$load("1wQU1"),
    $7442f8d5a8ec79a0$var$load("9ZAzg"),
    $7442f8d5a8ec79a0$var$load("kJSYP"),
    $7442f8d5a8ec79a0$var$load("cB5rV"),
    $7442f8d5a8ec79a0$var$load("aKnnM"),
    $7442f8d5a8ec79a0$var$load("kAAjo"),
    $7442f8d5a8ec79a0$var$load("fbRdC"),
    $7442f8d5a8ec79a0$var$load("dChec"),
    $7442f8d5a8ec79a0$var$load("2YffH"),
    $7442f8d5a8ec79a0$var$load("f35QR"),
    $7442f8d5a8ec79a0$var$load("eVYW1"),
    $7442f8d5a8ec79a0$var$load("ls0Um"),
    $7442f8d5a8ec79a0$var$load("020xd"),
    $7442f8d5a8ec79a0$var$load("eTBsW"),
    $7442f8d5a8ec79a0$var$load("1oiJ6"),
    $7442f8d5a8ec79a0$var$load("huUvS"),
    $7442f8d5a8ec79a0$var$load("3RdRc"),
    $7442f8d5a8ec79a0$var$load("98UJI"),
    $7442f8d5a8ec79a0$var$load("b0cmi"),
    $7442f8d5a8ec79a0$var$load("51haJ"),
    $7442f8d5a8ec79a0$var$load("jg5LT"),
    $7442f8d5a8ec79a0$var$load("7f9Fz"),
    $7442f8d5a8ec79a0$var$load("9XYQ9"),
    $7442f8d5a8ec79a0$var$load("ht6hk"),
    $7442f8d5a8ec79a0$var$load("jTaSF"),
    $7442f8d5a8ec79a0$var$load("9YBgR"),
    $7442f8d5a8ec79a0$var$load("7ZIlR"),
    $7442f8d5a8ec79a0$var$load("8fXIr"),
    $7442f8d5a8ec79a0$var$load("dVkhd"),
    $7442f8d5a8ec79a0$var$load("hhss7"),
    $7442f8d5a8ec79a0$var$load("dTsOE"),
    $7442f8d5a8ec79a0$var$load("7EorR"),
    $7442f8d5a8ec79a0$var$load("awqCy"),
    $7442f8d5a8ec79a0$var$load("7jSfd"),
    $7442f8d5a8ec79a0$var$load("4HZlX"),
    $7442f8d5a8ec79a0$var$load("kDqHr"),
    $7442f8d5a8ec79a0$var$load("6wr18"),
    $7442f8d5a8ec79a0$var$load("kjZZD"),
    $7442f8d5a8ec79a0$var$load("6nDfv"),
    $7442f8d5a8ec79a0$var$load("Wowvf"),
    $7442f8d5a8ec79a0$var$load("ffEVr"),
    $7442f8d5a8ec79a0$var$load("bTmOC"),
    $7442f8d5a8ec79a0$var$load("lFZaH")
]).then(()=>parcelRequire('cBfKJ'));

});

parcelRegister("eLvUt", function(module, exports) {

let $abfe35214d13280d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $abfe35214d13280d$var$load("cB5rV"),
    $abfe35214d13280d$var$load("aKnnM"),
    $abfe35214d13280d$var$load("1wZEW"),
    $abfe35214d13280d$var$load("2Mq3f"),
    $abfe35214d13280d$var$load("8KWDC"),
    $abfe35214d13280d$var$load("b0cmi"),
    $abfe35214d13280d$var$load("51haJ"),
    $abfe35214d13280d$var$load("lPQcc"),
    $abfe35214d13280d$var$load("kjZZD"),
    $abfe35214d13280d$var$load("7f9Fz"),
    $abfe35214d13280d$var$load("9fGNu"),
    $abfe35214d13280d$var$load("9XYQ9"),
    $abfe35214d13280d$var$load("3Bbwl"),
    $abfe35214d13280d$var$load("aeEUI"),
    $abfe35214d13280d$var$load("eY3St"),
    $abfe35214d13280d$var$load("bkd4T"),
    $abfe35214d13280d$var$load("hhss7"),
    $abfe35214d13280d$var$load("7EorR"),
    $abfe35214d13280d$var$load("awqCy"),
    $abfe35214d13280d$var$load("6wr18"),
    $abfe35214d13280d$var$load("cMlHc"),
    $abfe35214d13280d$var$load("6nDfv"),
    $abfe35214d13280d$var$load("Wowvf"),
    $abfe35214d13280d$var$load("ffEVr"),
    $abfe35214d13280d$var$load("kUykF")
]).then(()=>parcelRequire('27HWy'));

});

parcelRegister("1Ex9G", function(module, exports) {

let $13433ed0f81a0b68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $13433ed0f81a0b68$var$load("9w0Re"),
    $13433ed0f81a0b68$var$load("1wQU1"),
    $13433ed0f81a0b68$var$load("lUQAm"),
    $13433ed0f81a0b68$var$load("cB5rV"),
    $13433ed0f81a0b68$var$load("aKnnM"),
    $13433ed0f81a0b68$var$load("2YffH"),
    $13433ed0f81a0b68$var$load("cgmWe"),
    $13433ed0f81a0b68$var$load("2Mq3f"),
    $13433ed0f81a0b68$var$load("b0cmi"),
    $13433ed0f81a0b68$var$load("51haJ"),
    $13433ed0f81a0b68$var$load("2Gceu"),
    $13433ed0f81a0b68$var$load("jg5LT"),
    $13433ed0f81a0b68$var$load("7f9Fz"),
    $13433ed0f81a0b68$var$load("igTEs"),
    $13433ed0f81a0b68$var$load("9XYQ9"),
    $13433ed0f81a0b68$var$load("3kUQf"),
    $13433ed0f81a0b68$var$load("iFEfD"),
    $13433ed0f81a0b68$var$load("hhss7"),
    $13433ed0f81a0b68$var$load("7EorR"),
    $13433ed0f81a0b68$var$load("awqCy"),
    $13433ed0f81a0b68$var$load("6wr18"),
    $13433ed0f81a0b68$var$load("kjZZD"),
    $13433ed0f81a0b68$var$load("6nDfv"),
    $13433ed0f81a0b68$var$load("Wowvf"),
    $13433ed0f81a0b68$var$load("ffEVr"),
    $13433ed0f81a0b68$var$load("aUuEW")
]).then(()=>parcelRequire('aALia'));

});

parcelRegister("4sVPG", function(module, exports) {

let $3406a34ec5fc393b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3406a34ec5fc393b$var$load("9w0Re"),
    $3406a34ec5fc393b$var$load("1wQU1"),
    $3406a34ec5fc393b$var$load("9ZAzg"),
    $3406a34ec5fc393b$var$load("kJSYP"),
    $3406a34ec5fc393b$var$load("cB5rV"),
    $3406a34ec5fc393b$var$load("aKnnM"),
    $3406a34ec5fc393b$var$load("kAAjo"),
    $3406a34ec5fc393b$var$load("fbRdC"),
    $3406a34ec5fc393b$var$load("2YffH"),
    $3406a34ec5fc393b$var$load("f35QR"),
    $3406a34ec5fc393b$var$load("eVYW1"),
    $3406a34ec5fc393b$var$load("ls0Um"),
    $3406a34ec5fc393b$var$load("020xd"),
    $3406a34ec5fc393b$var$load("eTBsW"),
    $3406a34ec5fc393b$var$load("bYxCZ"),
    $3406a34ec5fc393b$var$load("6HBYC"),
    $3406a34ec5fc393b$var$load("eDqo1"),
    $3406a34ec5fc393b$var$load("lxiFd"),
    $3406a34ec5fc393b$var$load("1oiJ6"),
    $3406a34ec5fc393b$var$load("huUvS"),
    $3406a34ec5fc393b$var$load("d9TJ0"),
    $3406a34ec5fc393b$var$load("8nWJU"),
    $3406a34ec5fc393b$var$load("kpq80"),
    $3406a34ec5fc393b$var$load("98UJI"),
    $3406a34ec5fc393b$var$load("2Mq3f"),
    $3406a34ec5fc393b$var$load("hwLGf"),
    $3406a34ec5fc393b$var$load("bTmOC"),
    $3406a34ec5fc393b$var$load("a5wu4"),
    $3406a34ec5fc393b$var$load("b0cmi"),
    $3406a34ec5fc393b$var$load("51haJ"),
    $3406a34ec5fc393b$var$load("jg5LT"),
    $3406a34ec5fc393b$var$load("7f9Fz"),
    $3406a34ec5fc393b$var$load("5uN9h"),
    $3406a34ec5fc393b$var$load("9XYQ9"),
    $3406a34ec5fc393b$var$load("6aY84"),
    $3406a34ec5fc393b$var$load("5CaYW"),
    $3406a34ec5fc393b$var$load("ht6hk"),
    $3406a34ec5fc393b$var$load("lUQAm"),
    $3406a34ec5fc393b$var$load("jTaSF"),
    $3406a34ec5fc393b$var$load("9YBgR"),
    $3406a34ec5fc393b$var$load("7ZIlR"),
    $3406a34ec5fc393b$var$load("8fXIr"),
    $3406a34ec5fc393b$var$load("dVkhd"),
    $3406a34ec5fc393b$var$load("hhss7"),
    $3406a34ec5fc393b$var$load("dTsOE"),
    $3406a34ec5fc393b$var$load("7EorR"),
    $3406a34ec5fc393b$var$load("awqCy"),
    $3406a34ec5fc393b$var$load("7jSfd"),
    $3406a34ec5fc393b$var$load("4HZlX"),
    $3406a34ec5fc393b$var$load("kDqHr"),
    $3406a34ec5fc393b$var$load("6vhrJ"),
    $3406a34ec5fc393b$var$load("6wr18"),
    $3406a34ec5fc393b$var$load("kjZZD"),
    $3406a34ec5fc393b$var$load("6nDfv"),
    $3406a34ec5fc393b$var$load("Wowvf"),
    $3406a34ec5fc393b$var$load("ffEVr"),
    $3406a34ec5fc393b$var$load("dJOHz")
]).then(()=>parcelRequire('8Hi5s'));

});

parcelRegister("7BsWq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $6mKj3 = parcelRequire("6mKj3");

const $d70acb7f5d54408a$export$9143d6ac64592241 = ()=>{
    // IMPORTANT: If you add a new feature flag here, please make sure to add it to the
    // `featureFlagsPluginOptions` function in 'packages/editor/editor-presets-confluence/src/presets/full-page/pluginOptions/featureFlagsPluginOptions.ts`.
    return (0, $42omo.useMemo)(()=>({
            /**
			 * This feature flag has completed rollout in Confluence and is to be cleaned up from LD
			 * but cannot yet be cleaned up from editor component as pending rollout in other products first
			 */ 'lp-link-picker': true,
            'table-drag-and-drop': (0, $6mKj3.expVal)('platform_editor_tables_drag_and_drop', 'isEnabled', false),
            'table-with-fixed-column-widths-option': true,
            'renderer-tti-tracking': (0, $dh538.fg)('renderer_tti_tracking_confluence')
        }), []);
};
module.exports["useEditorFeatureFlags"] = $d70acb7f5d54408a$export$9143d6ac64592241;

});

parcelRegister("brsfB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $9UKrO = parcelRequire("9UKrO");


var $bedVD = parcelRequire("bedVD");


var $4GlQ9 = parcelRequire("4GlQ9");


var $4qzKl = parcelRequire("4qzKl");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");


var $eLV9q = parcelRequire("eLV9q");

function $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c({ push: push, userId: userId, cloudId: cloudId, featureFlags: featureFlags }) {
    const intl = (0, $8C5kA.default)();
    const feedFollowData = (0, $4GlQ9.useFeedFollow)();
    const getNavigateToTeamsApp = (0, $eLV9q.useGetNavigateToTeamsApp)();
    const handleProfileCardActions = (0, $42omo.useCallback)((pushProfileCardActions, loggedInUserId)=>(profileCardUserId)=>{
            const atlassianPeopleProfileUrl = (0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH));
            const teamsAppPersonProfileUrl = getNavigateToTeamsApp({
                type: 'USER',
                payload: {
                    userId: profileCardUserId
                }
            }).href;
            const followed = !!(profileCardUserId && feedFollowData?.followedUsers?.includes(profileCardUserId));
            return [
                {
                    label: intl.formatMessage({
                        id: "view.profile"
                    }),
                    callback: (0, $5XsiK.isTeamsAppEnabled)() ? undefined : ()=>{
                        pushProfileCardActions((0, $4qzKl.getAtlassianPeopleProfileUrl)(profileCardUserId, null, (0, $jlIaF.CONTEXT_PATH)));
                    },
                    target: (0, $5XsiK.isTeamsAppEnabled)() ? '_blank' : undefined,
                    link: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : atlassianPeopleProfileUrl
                },
                {
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bedVD.FeedFollow), {
                        followed: followed
                    }),
                    id: 'feed-follow-user',
                    callback: feedFollowData.getToggleFollowUser(profileCardUserId, followed, 'editor'),
                    shouldRender: (userData)=>feedFollowData.renderFeedFollow && Boolean(profileCardUserId) && profileCardUserId !== loggedInUserId && userData?.status === 'active'
                }
            ];
        }, [
        feedFollowData,
        getNavigateToTeamsApp,
        intl
    ]);
    return (0, $42omo.useMemo)(()=>{
        return (0, $9UKrO.getProfileCardProvider)(cloudId, handleProfileCardActions(push, userId), featureFlags ?? {});
    }, [
        cloudId,
        handleProfileCardActions,
        push,
        userId,
        featureFlags
    ]);
}
module.exports["useProfilecardProvider"] = $ce8c9e4f9afe9f9c$export$14fbdf1c2aa5816c;

});

parcelRegister("9UKrO", function(module, exports) {

var $bumSD = parcelRequire("bumSD");

function $88671cc112964e63$export$ecc18d1a90c31bf8(cloudId, getActions, /**
	 * @deprecated This is no longer used we should remove in a future version
	 */ featureFlags) {
    return Promise.resolve({
        cloudId: cloudId,
        resourceClient: (0, $bumSD.getProfileClient)(cloudId, featureFlags),
        getActions: getActions
    });
}
module.exports["getProfileCardProvider"] = $88671cc112964e63$export$ecc18d1a90c31bf8;

});

parcelRegister("1SPMi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");


var $3pfAb = parcelRequire("3pfAb");


var $bQm3c = parcelRequire("bQm3c");


var $2SowE = parcelRequire("2SowE");

const $c749b0358b0b3fb9$export$46da93e796378064 = (props)=>{
    const { objectId: objectId, objectType: objectType, children: children, source: source } = props;
    // setting default to development so in tests it doesn't fail due to being undefined
    const { environment: environment } = (0, $bQm3c.useSessionData)() || {};
    // setting default to development so in tests it doesn't fail due to being undefined
    const safeEnvironment = environment || 'DEVELOPMENT';
    const handleEvent = (0, $42omo.useCallback)((event)=>{
        const instanceName = safeEnvironment;
        event.update((payload)=>{
            let newPayload = (0, $2SowE.extendPayloadAttributes)(payload, {
                objectId: objectId,
                objectType: objectType,
                rendererSource: source
            });
            if (instanceName) newPayload = (0, $2SowE.extendPayloadAttributes)(newPayload, {
                instance: instanceName
            });
            return newPayload;
        });
    }, [
        safeEnvironment,
        objectId,
        objectType,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).editor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kDuN4.default), {
        onEvent: handleEvent,
        channel: (0, $3pfAb.FabricChannel).media
    }, children));
};
module.exports["RendererAnalyticsListener"] = $c749b0358b0b3fb9$export$46da93e796378064;

});

parcelRegister("3WO8q", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $eSUdr = parcelRequire("eSUdr");

const $b50b509b402b0702$export$89c600402d79f2bd = (0, $eSUdr.default)`mutation SetTaskStatusMutation($contentId:ID!$taskId:ID!$status:TaskStatus!){setTaskStatus(inlineTasksInput:{cid:$contentId taskId:$taskId status:$status trigger:VIEW_PAGE}){success}}`;



var $cgtv4 = parcelRequire("cgtv4");

const $c88a9f0357b47b1b$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    flagTitle: {
        id: "fabric-media-support.tasklist.error.flag.title",
        defaultMessage: "Something went wrong"
    },
    flagDescription: {
        id: "fabric-media-support.tasklist.error.flag.description",
        defaultMessage: "An error occurred while trying to change a task\u2019s status. Please try again later."
    }
});


class $cc5c5911f5458682$export$bfe822b045233127 {
    toggleTask(objectKey, state) {
        if (this._toggleTaskCallback) {
            this._toggleTaskCallback(objectKey, state);
            return Promise.resolve(state);
        } else /**
       * Using objectKey.objectAri may be a better alternative to passing in
       * contentId to the constructor. If it's reliable.
       */ // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        return (0, $hp2SH.getApolloClient)().mutate({
            mutation: (0, $b50b509b402b0702$export$89c600402d79f2bd),
            variables: {
                contentId: this.contentId,
                taskId: objectKey.localId,
                status: state === 'DONE' ? 'CHECKED' : 'UNCHECKED'
            }
        }).then((response)=>{
            const success = response?.data?.setTaskStatus?.success || false;
            if (!success) this.showErrorFlag();
            return state;
        }).catch(// this method is set to return `any` as a workaround for types.
        // Given that `TaskDecisionProvider.toggleTask` does not actually permit
        // `void` to be returned, what the `catch` block should probably be doing
        // is re-throwing the error that it got (at least that might match the
        // expectations). Since doing that will result in actual behavior changes
        // which I'm hesitant to perform, TS is simply silenced by `ny`-ing the
        // return type.
        (_)=>{
            /**
         * Note: there seems to be an issue whereby clicking a checkbox twice
         * quickly causes an error. I'm guessing something's not happy with a
         * mutation being issued while the previous one was still in-flight.
         * KTLO: we should probably create a queue as a workaround.
         * I'm (mdean2) not fixing this right now because I'm up against the
         * clock and the previous classic implementation suffered the same
         * problem.
         */ this.showErrorFlag();
        });
    }
    showErrorFlag() {
        this.flags.showErrorFlag({
            title: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagTitle),
            description: this.intl.formatMessage((0, $c88a9f0357b47b1b$export$a7357cdd1f0b0168).flagDescription)
        });
    }
    // Below are stubs, implemented to pacify TypeScript, and inherited from old
    // classic implementation.
    notifyRecentUpdates(_updateContext) {}
    subscribe(_objectKey, _handler) {}
    unsubscribe(_objectKey, _handler) {}
    unsubscribeRecentUpdates(_id) {}
    /* eslint-disable no-useless-constructor */ constructor(intl, flags, contentId, toggleTaskCallback){
        this.intl = intl;
        this.flags = flags;
        this.contentId = contentId;
        this.toggleTaskCallback = toggleTaskCallback;
        this._toggleTaskCallback = void 0;
        /**
     * eslint mistakenly thinks this is a useless constructor. It's not,
     * because TypeScript translates the 'public' arguments to actual code that
     * assigns them to instance variables.
     */ this._toggleTaskCallback = toggleTaskCallback;
    }
}
module.exports["ConfluenceTaskDecisionProvider"] = $cc5c5911f5458682$export$bfe822b045233127;

});

parcelRegister("gxhb8", function(module, exports) {
/* eslint-disable no-useless-constructor */ class $6c53b0825160fdb5$export$9a91b236871b318c {
    onFlush(callback) {
        if (!(callback instanceof Function)) throw new Error(`"onFlush" callback is supposed to be a function; saw ${typeof callback} instead`);
        this.onFlushCallback = callback;
    }
    /**
   * Forcefully flushes the batcher. Noop if current batch is empty.
   */ forceFlush() {
        // Currently force-flush is synchronous. Make sure the call sites are updated if
        // this is changed to a promise-based approach
        this.flush();
    }
    renewBatch() {
        const oldBatch = this.currentBatch;
        this.currentBatch = [];
        return oldBatch;
    }
    scheduleFlush() {
        if (!this.flushIntervalId) this.flushIntervalId = window.setInterval(this.flush, this.flushIntervalMs);
    }
    unscheduleFlush() {
        if (this.flushIntervalId) {
            window.clearInterval(this.flushIntervalId);
            this.flushIntervalId = undefined;
        }
    }
    constructor(flushIntervalMs){
        this.flushIntervalMs = flushIntervalMs;
        this.flushIntervalId = void 0;
        this.onFlushCallback = void 0;
        this.currentBatch = [];
        this.add = (item)=>{
            this.scheduleFlush();
            // If there's a previous task action for the same task, remove it
            this.currentBatch = this.currentBatch.filter((task)=>task.objectKey.localId !== item.objectKey.localId);
            this.currentBatch.push(item);
        };
        this.flush = ()=>{
            const batch = this.renewBatch();
            this.unscheduleFlush();
            if (batch.length === 0) return;
            try {
                if (this.onFlushCallback) this.onFlushCallback(batch);
            } catch (e) {
                // rethrow error asynchronously to allow other callbacks to execute
                setTimeout(()=>{
                    /* eslint-disable-next-line no-console */ console.error(`"onFlush" callback threw the below error. Please make sure your callbacks have proper error handling`);
                    throw e;
                }, 0);
            }
        };
    }
}
module.exports["TaskBatcher"] = $6c53b0825160fdb5$export$9a91b236871b318c;

});

parcelRegister("9aXRY", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");


var $kDja4 = parcelRequire("kDja4");


var $eVXGa = parcelRequire("eVXGa");

const $7a5968a7a46ee5ed$export$3b92560508ac384e = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    const isWhiteboardsEnabled = isWhiteboardFeatureEnabled('whiteboardsEnabled');
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    return {
        isEligibleCreateNewWhiteboard: edition !== (0, $euL71.ConfluenceEdition).FREE && isWhiteboardsEnabled && isAllowedToCreateWhiteboard
    };
};
module.exports["useIsEligibleCreateNewWhiteboard"] = $7a5968a7a46ee5ed$export$3b92560508ac384e;

});

parcelRegister("dXIrr", function(module, exports) {
/* PromptPopupContainer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");


var $dpPtd = parcelRequire("dpPtd");


var $6mKj3 = parcelRequire("6mKj3");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $7EIq6 = parcelRequire("7EIq6");


var $cLo2u = parcelRequire("cLo2u");

const $c4b4361024cd0a09$var$WHITEBOARD_COMPETITORS = [
    {
        name: 'Miro',
        domains: [
            /miro\.com/i
        ]
    },
    {
        name: 'Mural',
        domains: [
            /mural\.co/i
        ]
    },
    {
        name: 'Lucid',
        domains: [
            /lucid\.co/i
        ]
    },
    {
        name: 'Microsoft Whiteboard',
        domains: [
            /whiteboard\.office\.com/i,
            /wbd\.ms/i
        ]
    },
    {
        name: 'Figjam',
        domains: [
            /figma\.com\/board/i
        ]
    },
    {
        name: 'Google Jamboard',
        domains: [
            /jamboard\.google\.com/i
        ]
    },
    {
        name: 'Excalidraw',
        domains: [
            /excalidraw\.com/i
        ]
    },
    {
        name: 'Klaxoon',
        domains: [
            /klaxoon\.com/i
        ]
    }
];
const $c4b4361024cd0a09$export$ac6cace9ee376739 = (url)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey ?? undefined);
    const whiteboardCompetitor = $c4b4361024cd0a09$var$WHITEBOARD_COMPETITORS.find((competitor)=>competitor.domains.some((regex)=>regex.test(url)));
    return {
        competitorName: isCreateWhiteboardEnabled ? whiteboardCompetitor?.name : undefined
    };
};








const $623af4b4cfb0b8c1$var$DATABASE_COMPETITORS = [
    {
        name: 'Google Sheets',
        domains: [
            /docs\.google\.com\/spreadsheets/i
        ]
    },
    {
        name: 'Microsoft Lists',
        domains: [
            /lists\.live\.com/i
        ]
    },
    {
        name: 'SmartSheet',
        domains: [
            /smartsheet\.com/i
        ]
    },
    {
        name: 'Airtable',
        domains: [
            /airtable\.com/i
        ]
    },
    {
        name: 'AsanaList',
        domains: [
            /app\.asana\.com.*\/list\//i
        ]
    },
    {
        name: 'AsanaBoard',
        domains: [
            /app\.asana\.com.*\/board\//i
        ]
    }
];
const $623af4b4cfb0b8c1$export$42c019d1a8a7c555 = (url)=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { isCreateDatabaseEnabled: isCreateDatabaseEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey ?? undefined);
    const databaseCompetitor = $623af4b4cfb0b8c1$var$DATABASE_COMPETITORS.find((competitor)=>competitor.domains.some((regex)=>regex.test(url)));
    return {
        databaseCompetitorName: isCreateDatabaseEnabled ? databaseCompetitor?.name : undefined
    };
};


/* PromptPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 



var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");

var $xQxzY = parcelRequire("xQxzY");


var $lGgRw = parcelRequire("lGgRw");




var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $iXCQx = parcelRequire("iXCQx");


var $1Whri = parcelRequire("1Whri");


var $3HOqx = parcelRequire("3HOqx");


var $6B0jU = parcelRequire("6B0jU");


var $ZDq1z = parcelRequire("ZDq1z");


var $lE8sM = parcelRequire("lE8sM");


var $9VJDA = parcelRequire("9VJDA");


var $3sFtD = parcelRequire("3sFtD");


var $cO1el = parcelRequire("cO1el");


var $inPa6 = parcelRequire("inPa6");





var $euL71 = parcelRequire("euL71");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $bMPhU = parcelRequire("bMPhU");





var $fhofE = parcelRequire("fhofE");


var $ccP7J = parcelRequire("ccP7J");











var $3jwuS = parcelRequire("3jwuS");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");

const $48b719f4930c6be4$export$c2b5ddd2c8b4a98c = ()=>{
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ mode: livePageMode }] = (0, $efvKr.useLivePageMode)();
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    return (0, $42omo.useMemo)(()=>{
        if (isLivePage) return {
            isLivePage: isLivePage,
            pageMode: livePageMode || 'view' // 'edit' or 'view' for live pages
        };
        else return {
            isLivePage: isLivePage,
            pageMode: isEditorPage ? 'edit' : 'view' // 'edit' or 'view' for classic pages
        };
    }, [
        isLivePage,
        livePageMode,
        isEditorPage
    ]);
};





const $ff137fb7addc2b15$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    titleDatabase: {
        id: "prompt-competitor-link.prompt-database.title-database",
        defaultMessage: "Try Confluence databases"
    },
    descriptionDefaultDatabase: {
        id: "prompt-competitor-link.prompt-database.description-default-database",
        defaultMessage: "To organize content and data without switching tools, try Confluence databases."
    },
    createButtonDefaultDatabase: {
        id: "prompt-competitor-link.prompt-database.create-button-default-database",
        defaultMessage: "Create a database"
    },
    dismissButtonDatabase: {
        id: "prompt-competitor-link.prompt-database.dismiss-button",
        defaultMessage: "Do not show databases again"
    },
    databaseIconAltText: {
        id: "prompt-competitor-link.prompt-database.icon-alt-text",
        defaultMessage: "Confluence Database"
    },
    successFlagTitle: {
        id: "prompt-competitor-link.prompt-database.success-flag-title",
        defaultMessage: "Database added to content tree"
    },
    successFlagDescription: {
        id: "prompt-competitor-link.prompt-database.success-flag-description",
        defaultMessage: "The database has been created in the tree. Go to the database to move its location or change its permissions."
    },
    successFlagAction: {
        id: "prompt-competitor-link.prompt-database.success-flag-action",
        defaultMessage: "Go to database"
    },
    createdFlagTitle: {
        id: "prompt-competitor-link.prompt-database.created-flag-title",
        defaultMessage: "Database successfully created"
    },
    createdFlagDescription: {
        id: "prompt-competitor-link.prompt-database.created-flag-description",
        defaultMessage: "This database was created as a child item of the content you were working on."
    },
    createdFlagAction: {
        id: "prompt-competitor-link.prompt-database.created-flag-action",
        defaultMessage: "Go back to previous content"
    },
    defaultErrorFlagTitle: {
        id: "prompt-competitor-link.prompt-database.default-error-flag-title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "prompt-competitor-link.prompt-database.default-error-flag-description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    }
});


const $02f57d39ae5b5c3c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    titleWhiteboard: {
        id: "prompt-competitor-link.prompt-popup.title-whiteboard",
        defaultMessage: "Try Confluence whiteboards"
    },
    descriptionDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-popup.description-default-whiteboard",
        defaultMessage: "We noticed you pasted a {competitorName} link. Reduce context switching by using a Confluence whiteboard instead."
    },
    descriptionImportWhiteboard: {
        id: "prompt-competitor-link.prompt-popup.description-import-whiteboard",
        defaultMessage: "We noticed you pasted a {competitorName} link. Reduce context switching by importing your work to a Confluence whiteboard instead."
    },
    createButtonDefaultWhiteboard: {
        id: "prompt-competitor-link.prompt-popup.create-button-default-whiteboard",
        defaultMessage: "Create a whiteboard"
    },
    createButtonImportWhiteboard: {
        id: "prompt-competitor-link.prompt-popup.create-button-import-whiteboard",
        defaultMessage: "Import from {competitorName}"
    },
    dismissButton: {
        id: "prompt-competitor-link.prompt-popup.dismiss-button",
        defaultMessage: "Do not show whiteboards again"
    }
});
const $02f57d39ae5b5c3c$var$styles = {
    dismissPressable: "_bfhk1bhr _ca0qpxbi _n3tdpxbi _19bv1ejb _u5f31ejb",
    iconContainer: "_zulppxbi",
    titleContainer: "_1bah1yb4 _4cvr1h6o _1bsb1osq",
    pressable: "_1yt41b66 _2rko12b0 _1bsb1tcg _4t3i1tcg",
    pressableClosed: "_bfhkp2ly _irr3kca2",
    pressableOpen: "_1a37fqqo _bfhkkca2 _1cwg1i6y",
    popupBox: "_1bsb1gwv _ca0q12x7 _n3td12x7 _19bvutpp _u5f3utpp _19pkpxbi _otyrpxbi _18u01ejb _2hwx1ejb",
    popupBoxDatabase: "_18s8pxbi _1bsb1gwv",
    popupDescription: "_19pku2gc _otyrpxbi",
    showMoreIcon: "_bfhksm61",
    textContainer: "_1e0c1txw _2lx21bp4 _4cvr1y6m _ca0qv77o _n3tdv77o",
    ctaStyles: "_1yt4ze3t _18s8ze3t _4bfu1r31 _1hms8stv _ajmmnqa1 _11c8fhey _syaz13af _bfhk1j28 _9oik1r31 _1bnxglyw _jf4cnqa1"
};
const $02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE = (0, $eSUdr.gql)`
	mutation PromptPopupCreateContentInlineMutation(
		$createdInContentId: ID!
		$spaceKey: String
		$type: String!
	) {
		createContentInline(
			input: { createdInContentId: $createdInContentId, spaceKey: $spaceKey, type: $type }
		) {
			id
		}
	}
`;
const $02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE = (0, $eSUdr.gql)`
	query PromptPopupPaywallContentToDisableQuery {
		paywallContentToDisable(contentType: "whiteboard") {
			deactivationIdentifier
			link
			title
		}
	}
`;
const $02f57d39ae5b5c3c$var$CONTENT_TYPE_URL_FUNCTIONS = {
    whiteboard: (0, $fhofE.getFullWhiteboardUrl),
    database: (0, $ccP7J.getFullDatabaseUrl)
};
const $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS = [
    'miro',
    'mural'
];
const $02f57d39ae5b5c3c$var$CONTENT_TYPE_ONBOARDING_KEYS = {
    whiteboard: (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
    database: (0, $dBcar.PROMPT_DATABASE_COMPETITOR_LINK).DISMISSED
};
const $02f57d39ae5b5c3c$var$PromptComponent = ({ competitorName: competitorName, linkType: linkType, contentType: contentType })=>{
    const intl = (0, $8C5kA.default)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const spaceKey = (0, $cLo2u.useSpaceKey)() || '';
    const [currentPageId] = (0, $ep3mz.usePageContentId)();
    const [currentContentType] = (0, $ep3mz.useContentType)();
    const homepageId = (0, $bMPhU.useSpaceHomepageId)(spaceKey); // Blogs cannot have child content, so fall back to space homepage
    const parentContentId = currentContentType === 'blogpost' ? homepageId : currentPageId;
    const [isDismissOpen, setIsDismissOpen] = (0, $42omo.useState)(false);
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const isImport = $02f57d39ae5b5c3c$var$IMPORTER_COMPETITORS.some((competitor)=>competitorName?.toLowerCase().includes(competitor));
    const { data: paywallData, loading: paywallContentLoading } = (0, $xQxzY.useQuery)($02f57d39ae5b5c3c$var$PAYWALL_CONTENT_TO_DISABLE, {
        skip: contentType !== 'whiteboard' || !isImport || edition === (0, $euL71.ConfluenceEdition).PREMIUM,
        fetchPolicy: 'no-cache'
    });
    const paywallContentToDisable = paywallData?.paywallContentToDisable;
    const displayWbImportCta = contentType === 'whiteboard' && isImport && !paywallContentLoading && !(paywallContentToDisable?.deactivationIdentifier && paywallContentToDisable?.link && paywallContentToDisable?.title);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        displayWbImportCta,
        contentType
    ]);
    const [createContentInline, { loading: createContentLoading }] = (0, $1KmJq.useMutation)($02f57d39ae5b5c3c$var$CREATE_CONTENT_INLINE, {
        onCompleted: (data)=>{
            const contentId = data?.createContentInline?.id;
            if (!contentId) throw Error('no content id present');
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createdByFlow',
                    actionSubject: 'content',
                    objectId: contentId,
                    objectType: contentType,
                    containerId: spaceKey,
                    containerType: 'space',
                    source: 'competitorLink',
                    attributes: {
                        flow: 'competitorLink',
                        contentType: contentType,
                        linkType: linkType,
                        isImport: displayWbImportCta ? 'true' : 'false',
                        ...pageAnalyticsAttributes
                    },
                    nonPrivacySafeAttributes: {
                        linkDomain: competitorName
                    }
                }
            }).fire();
            setOnboardingState({
                key: $02f57d39ae5b5c3c$var$CONTENT_TYPE_ONBOARDING_KEYS[contentType],
                value: 'true'
            });
            const urlFunction = $02f57d39ae5b5c3c$var$CONTENT_TYPE_URL_FUNCTIONS[contentType]; // check valid content type
            if (urlFunction) {
                let url = urlFunction(contentId, spaceKey);
                if (displayWbImportCta) {
                    const urlObj = new URL(url);
                    const searchParams = new URLSearchParams(urlObj.search);
                    searchParams.set(`open${competitorName}ImportTool`, 'true');
                    urlObj.search = searchParams.toString();
                    url = urlObj.toString();
                }
                window.open(url, '_blank', 'noreferrer, noopener');
                if (contentType === 'database') showFlag?.({
                    id: 'competitor-link-success-flag',
                    title: intl.formatMessage((0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).successFlagTitle),
                    description: intl.formatMessage((0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).successFlagDescription),
                    isAutoDismiss: false,
                    icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                        color: "var(--ds-icon-success, #6A9A23)",
                        label: "success"
                    }),
                    actions: [
                        {
                            content: intl.formatMessage((0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).successFlagAction),
                            href: url,
                            onClick: ()=>{
                                createAnalyticsEvent({
                                    type: 'sendUIEvent',
                                    data: {
                                        action: 'clicked',
                                        actionSubject: 'competitorLinkPrompt',
                                        actionSubjectId: 'contentSuccessFlagAction',
                                        source: 'competitorLink',
                                        attributes: {
                                            linkContentType: contentType,
                                            linkType: linkType,
                                            ...pageAnalyticsAttributes
                                        }
                                    }
                                }).fire();
                            }
                        }
                    ]
                });
            }
        }
    });
    const handleLinkClick = async ()=>{
        if (createContentLoading || !parentContentId) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'createButton',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false',
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName,
                    linkContentType: contentType,
                    linkType: linkType,
                    isImport: displayWbImportCta ? 'true' : 'false'
                }
            }
        }).fire();
        await createContentInline({
            variables: {
                createdInContentId: parentContentId,
                spaceKey: spaceKey,
                type: contentType
            }
        });
    };
    let descriptionText;
    if (contentType === 'database') descriptionText = intl.formatMessage((0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).descriptionDefaultDatabase, {
        competitorName: competitorName
    });
    else {
        const whiteboardDescription = displayWbImportCta ? $02f57d39ae5b5c3c$export$a7357cdd1f0b0168.descriptionImportWhiteboard : $02f57d39ae5b5c3c$export$a7357cdd1f0b0168.descriptionDefaultWhiteboard;
        descriptionText = intl.formatMessage(whiteboardDescription, {
            competitorName: competitorName
        });
    }
    let createText;
    if (contentType === 'database') createText = intl.formatMessage((0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).createButtonDefaultDatabase);
    else {
        const whiteboardCreateButton = displayWbImportCta ? $02f57d39ae5b5c3c$export$a7357cdd1f0b0168.createButtonImportWhiteboard : $02f57d39ae5b5c3c$export$a7357cdd1f0b0168.createButtonDefaultWhiteboard;
        createText = intl.formatMessage(whiteboardCreateButton, {
            competitorName: competitorName
        });
    }
    const dismissText = intl.formatMessage(contentType === 'database' ? (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).dismissButtonDatabase : $02f57d39ae5b5c3c$export$a7357cdd1f0b0168.dismissButton);
    const handleDismissClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptDismiss',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setOnboardingState({
            key: $02f57d39ae5b5c3c$var$CONTENT_TYPE_ONBOARDING_KEYS[contentType],
            value: 'true'
        });
        setIsDismissOpen(false);
    }, [
        createAnalyticsEvent,
        setOnboardingState,
        linkType,
        pageAnalyticsAttributes,
        contentType
    ]);
    const handleMoreMenuClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptMoreMenu',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsDismissOpen(!isDismissOpen);
    }, [
        createAnalyticsEvent,
        isDismissOpen,
        linkType,
        pageAnalyticsAttributes,
        contentType
    ]);
    const titleText = contentType === 'database' ? intl.formatMessage((0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).titleDatabase) : intl.formatMessage($02f57d39ae5b5c3c$export$a7357cdd1f0b0168.titleWhiteboard); // TODO: Add `shouldRenderToParent = true` to make popup experience accessible. See https://a11y.atlassian.net/browse/JCATS-788
    // shouldRenderToParent currently forced to false to prevent popup from being rendered in the wrong place
    const dismissPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: false,
        isOpen: isDismissOpen,
        onClose: ()=>setIsDismissOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                xcss: $02f57d39ae5b5c3c$var$styles.dismissPressable,
                onClick: handleDismissClick,
                testId: "competitor-link-prompt-dismiss-button"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, dismissText)),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...triggerProps,
                xcss: $02f57d39ae5b5c3c$var$styles.showMoreIcon,
                onClick: handleMoreMenuClick,
                testId: "competitor-link-prompt-dismiss-menu"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: dismissText,
                size: "medium"
            }))
    });
    const titleSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $02f57d39ae5b5c3c$var$styles.titleContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "xsmall"
    }, titleText), dismissPopup);
    const contentSection = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $02f57d39ae5b5c3c$var$styles.popupDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, descriptionText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
        onClick: handleLinkClick,
        xcss: $02f57d39ae5b5c3c$var$styles.ctaStyles
    }, createText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $02f57d39ae5b5c3c$var$styles.popupBoxDatabase,
        testId: "competitor-link-prompt-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $02f57d39ae5b5c3c$var$styles.iconContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lE8sM.default), {
        key: contentType === 'database' ? 'databaseIcon' : 'whiteboardIcon',
        icon: contentType === 'database' ? (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))) : (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
        label: titleText,
        appearance: contentType === 'database' ? 'purpleBold' : 'tealBold',
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $02f57d39ae5b5c3c$var$styles.textContainer
    }, titleSection, contentSection)));
};
const $02f57d39ae5b5c3c$export$79356a2b3ed5a31d = ({ competitorName: competitorName, linkType: linkType, contentType: contentType })=>{
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const pageAnalyticsAttributes = (0, $48b719f4930c6be4$export$c2b5ddd2c8b4a98c)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptIcon',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                },
                nonPrivacySafeAttributes: {
                    linkDomain: competitorName
                }
            }
        }).fire();
    }, [
        competitorName,
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType
    ]);
    const handlePromptPopupClose = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'closed',
                actionSubject: 'competitorLinkPrompt',
                actionSubjectId: 'promptPopup',
                source: 'competitorLink',
                attributes: {
                    linkContentType: contentType,
                    linkType: linkType,
                    ...pageAnalyticsAttributes
                }
            }
        }).fire();
        setIsOpen(false);
    }, [
        createAnalyticsEvent,
        linkType,
        pageAnalyticsAttributes,
        contentType
    ]);
    const handlePromptPopupClick = (0, $42omo.useCallback)(()=>{
        if (isOpen) handlePromptPopupClose();
        else {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'competitorLinkPrompt',
                    actionSubjectId: 'promptIcon',
                    source: 'competitorLink',
                    attributes: {
                        linkContentType: contentType,
                        linkType: linkType,
                        ...pageAnalyticsAttributes
                    }
                }
            }).fire();
            setIsOpen(!isOpen);
        }
    }, [
        createAnalyticsEvent,
        handlePromptPopupClose,
        isOpen,
        linkType,
        pageAnalyticsAttributes,
        contentType
    ]);
    return(// TODO: Add `shouldRenderToParent = true` to make popup experience accessible. See https://a11y.atlassian.net/browse/JCATS-788
    // shouldRenderToParent currently forced to false to prevent popup from being rendered in the wrong place
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.Popup), {
        shouldRenderToParent: false,
        isOpen: isOpen,
        onClose: handlePromptPopupClose,
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($02f57d39ae5b5c3c$var$PromptComponent, {
                competitorName: competitorName,
                linkType: linkType,
                contentType: contentType
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fVUfS.default), {
                ...triggerProps,
                onClick: handlePromptPopupClick,
                xcss: (0, $1Whri.cx)($02f57d39ae5b5c3c$var$styles.pressable, isOpen ? $02f57d39ae5b5c3c$var$styles.pressableOpen : $02f57d39ae5b5c3c$var$styles.pressableClosed),
                testId: "competitor-link-prompt-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3HOqx))), {
                color: "var(--ds-icon-discovery, #AF59E1)",
                label: intl.formatMessage(contentType === 'database' ? (0, $ff137fb7addc2b15$export$a7357cdd1f0b0168).titleDatabase : $02f57d39ae5b5c3c$export$a7357cdd1f0b0168.titleWhiteboard)
            }))
    }));
};


const $ded78f64c507c664$var$styles = {
    promptContainer: "_1e0c116y _4cvr1h6o _2hwxv77o _18u0v77o"
};
const $ded78f64c507c664$var$VALID_LINK_TYPES = [
    'inline',
    'card',
    'embed'
];
const $ded78f64c507c664$var$getCompetitorContentType = (whiteboardCompetitorName, databaseCompetitorName)=>{
    if (whiteboardCompetitorName) return 'whiteboard';
    if (databaseCompetitorName) return 'database';
    return undefined;
};
const $ded78f64c507c664$var$PromptPopupContainerInner = ({ sourceUrl: sourceUrl, linkType: linkType })=>{
    const { data: onboardingStateData, loading: loading, error: error } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.PROMPT_WHITEBOARD_COMPETITOR_LINK_DISMISSED).PROMPT_DISMISSED,
        (0, $dBcar.PROMPT_DATABASE_COMPETITOR_LINK).DISMISSED
    ]);
    const { isPromptDismissed: isPromptWhiteboardDismissed, isPromptDatabaseDismissed: isPromptDatabaseDismissed } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const { competitorName: whiteboardCompetitorName } = (0, $c4b4361024cd0a09$export$ac6cace9ee376739)(sourceUrl);
    const { databaseCompetitorName: databaseCompetitorName } = (0, $623af4b4cfb0b8c1$export$42c019d1a8a7c555)(sourceUrl);
    const competitorContentType = $ded78f64c507c664$var$getCompetitorContentType(whiteboardCompetitorName, databaseCompetitorName);
    const competitorName = whiteboardCompetitorName || databaseCompetitorName;
    if (!competitorContentType || !competitorName) return null;
    const validLinkType = linkType && $ded78f64c507c664$var$VALID_LINK_TYPES.includes(linkType) ? linkType : undefined;
    const contentTypeConfig = {
        database: {
            isExpEnabled: ()=>(0, $6mKj3.expValEquals)('cc_fd_prompt_database_competitor_link', 'cohort', 'experiment'),
            isDismissed: isPromptDatabaseDismissed
        },
        whiteboard: {
            isExpEnabled: ()=>(0, $6mKj3.expValEquals)('prompt_whiteboard_competitor_link', 'cohort', 'experiment'),
            isDismissed: isPromptWhiteboardDismissed
        }
    };
    const { isExpEnabled: isExpEnabled, isDismissed: isDismissed } = contentTypeConfig[competitorContentType];
    return !loading && !error && !isDismissed && isExpEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $ded78f64c507c664$var$styles.promptContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $02f57d39ae5b5c3c$export$79356a2b3ed5a31d), {
        competitorName: competitorName,
        linkType: validLinkType,
        contentType: competitorContentType
    }));
};
const $ded78f64c507c664$export$342f0658478a7894 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dpPtd.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ded78f64c507c664$var$PromptPopupContainerInner, props));
module.exports["PromptPopupContainer"] = $ded78f64c507c664$export$342f0658478a7894;

});

parcelRegister("fhofE", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");

const $db55d2db1b1085cb$var$BASE_URL_META_SELECTOR = "meta[name='confluence-base-url']";
const $db55d2db1b1085cb$var$getBaseUrlForLocalhost = ()=>{
    const baseUrlFromMeta = window.document.querySelector($db55d2db1b1085cb$var$BASE_URL_META_SELECTOR)?.getAttribute('content') ?? 'https://hello.atlassian.net/wiki';
    return baseUrlFromMeta.substring(0, baseUrlFromMeta.length - 5);
};
const $db55d2db1b1085cb$export$f654b28f82155665 = ()=>{
    if (typeof window.location === 'undefined') return '';
    const baseUrl = window.location.origin;
    // If we are in localhost, we use the base URL from the meta tag
    if (new URL(baseUrl).hostname === 'localhost') return $db55d2db1b1085cb$var$getBaseUrlForLocalhost();
    return baseUrl;
};
const $db55d2db1b1085cb$export$420f191ed44b660f = (contentId, spaceKey)=>`${$db55d2db1b1085cb$export$f654b28f82155665()}${(0, $1NBp8.WHITEBOARD_BOARD).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    })}`;
module.exports["getFullWhiteboardUrl"] = $db55d2db1b1085cb$export$420f191ed44b660f;

});

parcelRegister("ccP7J", function(module, exports) {

var $gtD4K = parcelRequire("gtD4K");


var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $5aaqS = parcelRequire("5aaqS");


var $6B0jU = parcelRequire("6B0jU");


var $dk0le = parcelRequire("dk0le");


var $4ymSL = parcelRequire("4ymSL");


var $c4TO3 = parcelRequire("c4TO3");


var $6mKj3 = parcelRequire("6mKj3");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $1NBp8 = parcelRequire("1NBp8");


var $jn9ek = parcelRequire("jn9ek");


var $irVI7 = parcelRequire("irVI7");


var $aJPUt = parcelRequire("aJPUt");


var $ge2sX = parcelRequire("ge2sX");


var $f7i8j = parcelRequire("f7i8j");

/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $87d59ca675d7b4ec$export$94bf7b80e41f7d2b = (0, $eSUdr.default)`mutation CreateContentInlineMutation($createdInContentId:ID!$spaceKey:String){createContentInline(input:{createdInContentId:$createdInContentId spaceKey:$spaceKey type:"database"}){id}}`;



var $cgtv4 = parcelRequire("cgtv4");


var $jhwJP = parcelRequire("jhwJP");

const $7c2c9699294e7927$var$i18nBase = (0, $cgtv4.defineMessages)({
    manifestDescription: {
        id: "confluence-databases-extension.description",
        defaultMessage: "Create an empty database table"
    },
    manifestTitle: {
        id: "confluence-databases-extension.title",
        defaultMessage: "Database extension"
    },
    createDatabaseTitle: {
        id: "confluence-databases-extension.create-database.title",
        defaultMessage: "New database"
    },
    createDatabaseDescription: {
        id: "confluence-databases-extension.create-database.description",
        defaultMessage: "Create an empty database table"
    },
    referenceDatabaseTitle: {
        id: "confluence-databases-extension.reference-database.title",
        defaultMessage: "Embed database"
    },
    referenceDatabaseDescription: {
        id: "confluence-databases-extension.reference-database.description",
        defaultMessage: "Display an existing database, entry, or value"
    },
    referenceDatabaseModalLabel: {
        id: "confluence-databases-extension.reference-database.modal-label",
        defaultMessage: "Reference database modal"
    },
    createDatabaseIconAltText: {
        id: "confluence-databases-extension.create-database.icon-alt-text",
        defaultMessage: "Create database icon"
    },
    referenceDatabaseIconAltText: {
        id: "confluence-databases-extension.reference-database.icon-alt-text",
        defaultMessage: "Reference database icon"
    },
    successFlagTitle: {
        id: "confluence-databases-extension.success-flag.title",
        defaultMessage: "Database added under this content "
    },
    successFlagAction: {
        id: "confluence-databases-extension.success-flag.action",
        defaultMessage: "Open database in new tab"
    },
    successFlagDescription: {
        id: "confluence-databases-extension.success-flag.description",
        defaultMessage: "To view this database in full and edit it with ease, open it in a new tab."
    },
    defaultErrorFlagTitle: {
        id: "confluence-databases-extension.error-flag.title",
        defaultMessage: "We\u2019re unable to create right now"
    },
    defaultErrorFlagDescription: {
        id: "confluence-databases-extension.error-flag.description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    },
    parentPageMovedErrorTitle: {
        id: "confluence-databases-extension.error.parent-page-moved-error-title",
        defaultMessage: "The parent has moved"
    },
    parentPageMovedErrorDescription: {
        id: "confluence-databases-extension.error.parent-page-moved-error-description",
        defaultMessage: "Refresh to create in the new location."
    },
    permissionRemovedErrorTitle: {
        id: "confluence-databases-extension.error.permission-removed-error-title",
        defaultMessage: "We\u2019re unable to create this content"
    },
    permissionRemovedErrorDescription: {
        id: "confluence-databases-extension.error.permission-removed-error-description",
        defaultMessage: "You don\u2019t have permission to create here or the space has been recently deleted."
    },
    invalidParentErrorTitle: {
        id: "confluence-databases-extension.error.invalid-parent-error-title",
        defaultMessage: "We can\u2019t create a database"
    },
    invalidParentErrorDescription: {
        id: "confluence-databases-extension.error.invalid-parent-error-description",
        defaultMessage: "This page was deleted or archived. You can create a database on a different page."
    },
    databaseBoardLayoutTitle: {
        id: "confluence-databases-extension.database-board-layout.title",
        defaultMessage: "Board layout (Database)"
    },
    databaseBoardLayoutDescription: {
        id: "confluence-databases-extension.database-board-layout.description",
        defaultMessage: "Structure data in a kanban board "
    },
    databaseBoardLayoutIconAltText: {
        id: "confluence-databases-extension.database-board-layout.icon-alt-text",
        defaultMessage: "Database Board icon"
    },
    databaseGalleryLayoutTitle: {
        id: "confluence-databases-extension.database-gallery-layout.title",
        defaultMessage: "Gallery layout (Database)"
    },
    databaseGalleryLayoutDescription: {
        id: "confluence-databases-extension.database-gallery-layout.description",
        defaultMessage: "Structure data in a gallery of cards"
    },
    databaseGalleryLayoutIconAltText: {
        id: "confluence-databases-extension.database-gallery-layout.icon-alt-text",
        defaultMessage: "Database gallery icon"
    },
    databaseTableLayoutTitle: {
        id: "confluence-databases-extension.database-table-layout.title",
        defaultMessage: "Table layout (Database)"
    },
    databaseTableLayoutDescription: {
        id: "confluence-databases-extension.database-table-layout.description",
        defaultMessage: "Structure data in a dynamic table"
    },
    databaseTableLayoutIconAltText: {
        id: "confluence-databases-extension.database-table-layout.icon-alt-text",
        defaultMessage: "Database table icon"
    }
});
const $7c2c9699294e7927$var$i18nLiveDocs = (0, $cgtv4.defineMessages)({
    invalidParentErrorDescription: {
        id: "confluence-databases-extension.error.invalid-parent-error-description.livedocs",
        defaultMessage: "This item was deleted or archived. You can create a database on a different page or live doc."
    }
});
const $7c2c9699294e7927$export$a7357cdd1f0b0168 = (0, $jhwJP.mergeLiveDocI18n)($7c2c9699294e7927$var$i18nBase, $7c2c9699294e7927$var$i18nLiveDocs);


var $bc87b26567284590$exports = {};
$bc87b26567284590$exports = new URL("InlineCreateIcon.2a8cad4b.svg", import.meta.url).toString();


var $c7f5a98f0ee5cc1e$exports = {};
$c7f5a98f0ee5cc1e$exports = new URL("InlineEmbedIcon.eb3ad338.svg", import.meta.url).toString();






var $8CZUH = parcelRequire("8CZUH");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $bQm3c = parcelRequire("bQm3c");





var $9wGTI = parcelRequire("9wGTI");






var $j6S25 = parcelRequire("j6S25");


var $7J5Uc = parcelRequire("7J5Uc");

const $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944 = ()=>{
    const params = new URLSearchParams(window.location.search);
    const version = params.get('databases-frontend') || undefined;
    const [{ theme: theme }] = (0, $7J5Uc.useThemingState)();
    return (0, $42omo.useMemo)(()=>{
        const url = new URL('/databases/standalone', window.location.origin);
        if (version) url.searchParams.set('bifrost-override', version);
        if (theme) {
            url.pathname = `${url.pathname}/${theme.colorMode === 'dark' ? 'index-dark.html' : 'index.html'}`;
            url.searchParams.set('themeState', encodeURIComponent((0, $j6S25.themeObjectToString)(theme)));
        }
        url.searchParams.set('referencing', 'true');
        url.searchParams.set('parentProduct', 'smartLink');
        const finalUrlParts = [
            url.pathname
        ];
        if (Array.from(url.searchParams).length > 0) finalUrlParts.push(url.searchParams.toString());
        return finalUrlParts.join('?');
    }, [
        version,
        theme
    ]);
};


/** @graphql cc **/ 


const $99c271f0553eef8e$export$43002ea73777e683 = (0, $eSUdr.default)`query DatabaseReferenceModalCurrentUserQuery{user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}emails{value isPrimary}locale}}`;






var $kpYGL = parcelRequire("kpYGL");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");

const $95791232fc1c8d49$var$embedReferenceContainerStyles = (0, $ecnYn.xcss)({
    maxWidth: '100%',
    height: '600px',
    overflow: 'hidden'
});
const $95791232fc1c8d49$var$previewContainerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%',
    paddingRight: 'space.200',
    paddingBottom: 'space.100'
});
const $95791232fc1c8d49$var$placeholderContainerStyles = (0, $ecnYn.xcss)({
    width: '100%',
    height: '100%'
});
const $95791232fc1c8d49$var$placeholderTextStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $95791232fc1c8d49$var$referenceOptionsContainerStyles = (0, $ecnYn.xcss)({
    width: '320px',
    height: '600px',
    borderLeftWidth: 'border.width.selected',
    borderLeftStyle: 'solid',
    borderColor: 'color.border'
});
const $95791232fc1c8d49$var$formHeaderContainerStyles = (0, $ecnYn.xcss)({
    padding: 'space.300',
    paddingBottom: 'space.250',
    position: 'relative'
});
const $95791232fc1c8d49$var$referencePickerContainerStyles = (0, $ecnYn.xcss)({
    minHeight: '0',
    paddingTop: 'space.025',
    paddingRight: 'space.300',
    paddingBottom: 'space.025',
    paddingLeft: 'space.300'
});
const $95791232fc1c8d49$var$optionGroupContainerStyles = (0, $ecnYn.xcss)({
    marginBottom: 'space.300'
});
const $95791232fc1c8d49$var$OptionGroup = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignBlock: "start",
        space: "space.050",
        xcss: $95791232fc1c8d49$var$optionGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 56,
        height: 14,
        borderRadius: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 272,
        height: 40,
        borderRadius: 3
    }));
};
const $95791232fc1c8d49$export$21f44e8ab2843801 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        xcss: $95791232fc1c8d49$var$embedReferenceContainerStyles,
        testId: "legacy-reference-database-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: $95791232fc1c8d49$var$previewContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.250",
        xcss: $95791232fc1c8d49$var$placeholderContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 93,
        height: 93,
        borderRadius: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.150",
        xcss: $95791232fc1c8d49$var$placeholderTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 216,
        height: 14,
        borderRadius: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 132,
        height: 14,
        borderRadius: 18
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $95791232fc1c8d49$var$referenceOptionsContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignBlock: "center",
        spread: "space-between",
        xcss: $95791232fc1c8d49$var$formHeaderContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 145,
        height: 14,
        borderRadius: 18
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 24,
        height: 24,
        borderRadius: 5
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $95791232fc1c8d49$var$referencePickerContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95791232fc1c8d49$var$OptionGroup, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95791232fc1c8d49$var$OptionGroup, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($95791232fc1c8d49$var$OptionGroup, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        alignInline: "end",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: 3
    })))));
};


/* DatabaseReferenceModalSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");

const $c190662e98183b48$var$skeletonStyles = {
    embedReferenceContainer: "_1rjcu2gc _18zr1ejb",
    placeholderContainer: "_1bsb1osq _4t3irdnh",
    placeholderText: "_1bsb1osq",
    footerContainer: "_n3td1ejb"
};
const $c190662e98183b48$export$c5d436bba21e5326 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $c190662e98183b48$var$skeletonStyles.embedReferenceContainer,
        space: "space.200",
        testId: "reference-database-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        space: "space.150",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 240,
        height: 40,
        borderRadius: 3
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.400",
        xcss: $c190662e98183b48$var$skeletonStyles.placeholderContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 108,
        height: 108,
        borderRadius: "100%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 316,
        height: 14,
        borderRadius: 18
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $u9agA.default), {
        alignInline: "end",
        space: "space.100",
        xcss: $c190662e98183b48$var$skeletonStyles.footerContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
        isShimmering: true,
        width: 61,
        height: 32,
        borderRadius: 3
    })));
};


const $dc4f221a49e0d4ac$var$isDatabaseUrl = (value)=>/database\/\d+/.test(value);
const $dc4f221a49e0d4ac$export$8480276ebb3b339b = ({ onClose: onClose, intl: intl })=>{
    const iframeRef = (0, $42omo.useRef)(null);
    const [identity, setIdentity] = (0, $42omo.useState)(null);
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const initialUrl = (0, $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944)();
    const [isLoading, setIsLoading] = (0, $42omo.useState)(true);
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        (0, $hp2SH.getApolloClient)().query({
            query: (0, $99c271f0553eef8e$export$43002ea73777e683)
        }).then(({ data: data })=>{
            setIdentity({
                accountId: data?.user?.id,
                nickname: data?.user?.displayName,
                picture: data?.user?.photos?.find((photo)=>photo?.isPrimary)?.value,
                email: data?.user?.emails?.find((email)=>email?.isPrimary)?.value,
                locale: data?.user?.locale
            });
        });
    }, []);
    const bridgeData = {
        cloudId: cloudId,
        activationId: activationId,
        userId: userId,
        identity: identity
    };
    const messageCallback = (0, $42omo.useCallback)((event)=>{
        const isFromExpectedIframe = iframeRef.current && event.source === iframeRef.current.contentWindow;
        if (isFromExpectedIframe) try {
            const data = JSON.parse(event.data);
            if (data.finalDatabaseUrl && $dc4f221a49e0d4ac$var$isDatabaseUrl(data.finalDatabaseUrl)) onClose(data.finalDatabaseUrl);
            else if (data.cancelDatabaseReference) onClose(undefined);
            else if (data.databaseReferencingComponentLoaded) setIsLoading(false);
        } catch (error) {}
    }, [
        onClose,
        iframeRef
    ]);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        messageCallback
    ]);
    const SkeletonComponent = (0, $9wGTI.fg)('databases-frontend-embed-database-modal') ? (0, $c190662e98183b48$export$c5d436bba21e5326) : (0, $95791232fc1c8d49$export$21f44e8ab2843801);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        width: 1200,
        height: 592,
        onClose: ()=>onClose(undefined),
        testId: "reference-database-modal",
        label: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseModalLabel)
    }, (0, $9wGTI.fg)('databases-frontend-embed-database-modal') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseTitle))), isLoading || !identity ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(SkeletonComponent, null) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '600px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            border: '0px',
            display: !isLoading && identity ? 'block' : 'none'
        },
        src: initialUrl,
        ...identity ? {
            'data-bridge-data': JSON.stringify(bridgeData)
        } : {},
        title: "reference-database-frame",
        ref: iframeRef
    })));
};






var $9hlns = parcelRequire("9hlns");








/** @graphql cc **/ 


const $28d009c4054ac02e$export$8db4136a8204c678 = (0, $eSUdr.default)`query DatabaseValueContainerContentUnifiedQuery($contentId:ID!){content(id:$contentId){nodes{id referenceId space{id key name}}}user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}emails{value isPrimary}locale}}`;


const $e75add8c1d946f03$export$df287bda027f951a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ contentId: contentId, entryId: entryId, fieldId: fieldId, isEdit: isEdit })=>{
    const iframeRef = (0, $42omo.useRef)(null);
    const [content, setContent] = (0, $42omo.useState)(null);
    const [dataLoaded, setDataLoaded] = (0, $42omo.useState)(false);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const databaseUrl = new URL((0, $e8cbe0a1e77b1d69$export$3f6d3dddadd0c944)(), window.location.origin);
    const [identity, setIdentity] = (0, $42omo.useState)(null);
    const { activationId: activationId, userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    (0, $42omo.useEffect)(()=>{
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        (0, $hp2SH.getApolloClient)().query({
            query: (0, $28d009c4054ac02e$export$8db4136a8204c678),
            variables: {
                contentId: contentId
            }
        }).then(({ data: data })=>{
            setContent({
                contentReferenceId: data.content?.nodes?.[0]?.referenceId,
                spaceId: data.content?.nodes?.[0]?.space?.id,
                spaceKey: data.content?.nodes?.[0]?.space?.key,
                spaceName: data.content?.nodes?.[0]?.space?.name
            });
            setIdentity({
                accountId: data?.user?.id,
                nickname: data?.user?.displayName,
                picture: data?.user?.photos?.find((photo)=>photo?.isPrimary)?.value,
                email: data?.user?.emails?.find((email)=>email?.isPrimary)?.value,
                locale: data?.user?.locale
            });
            setDataLoaded(true);
        });
    }, [
        contentId
    ]);
    const bridgeData = {
        cloudId: cloudId,
        activationId: activationId,
        userId: userId,
        identity: identity,
        contentId: contentId,
        ...content ? {
            content: content
        } : {}
    };
    const messageCallback = (0, $42omo.useCallback)((event)=>{
        const isFromExpectedIframe = iframeRef.current && event.source === iframeRef.current.contentWindow;
        if (isFromExpectedIframe) try {
            const data = JSON.parse(event.data);
            if (data.method === 'resize' && 'width' in data && 'height' in data) {
                setWidth(data.width);
                setHeight(data.height);
            }
        } catch (error) {}
    }, []);
    (0, $42omo.useEffect)(()=>{
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        messageCallback
    ]);
    if (entryId && fieldId && contentId) {
        databaseUrl.searchParams.delete('referencing');
        databaseUrl.searchParams.set('contentId', contentId);
        databaseUrl.searchParams.set('entryId', entryId);
        databaseUrl.searchParams.set('fieldId', fieldId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("iframe", {
            style: {
                width: `${width}px`,
                height: `${height}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                border: '0px',
                pointerEvents: isEdit ? 'none' : 'auto',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                verticalAlign: 'middle'
            },
            src: databaseUrl.toString(),
            ...dataLoaded ? {
                'data-bridge-data': JSON.stringify(bridgeData)
            } : {},
            title: "database-value-frame",
            ref: iframeRef
        }), width === 0 || height === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            testId: "database-value-spinner"
        }) : null);
    }
    return null;
});


// !IMPORTANT, this key databases-create-with-template-type should not be renamed as canvas/database uses it to determine which template to apply
const $dfcefa6efd7a826f$var$LS_DB_TEMPLATE_KEY = 'databases-create-with-template-type';
const $dfcefa6efd7a826f$export$d1ce03628c550fb = 10000;
const $dfcefa6efd7a826f$var$isParentPageMovedError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('The parent space does not match the desired space')));
    return false;
};
const $dfcefa6efd7a826f$var$isInvalidParentError = (error)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some((graphQLError)=>graphQLError.extensions.data.errors.some((nestedError)=>nestedError.message.key.includes('Invalid potential parent passed')));
    return false;
};
const $dfcefa6efd7a826f$export$56cb25c20f68202b = (error)=>{
    if ($dfcefa6efd7a826f$var$isParentPageMovedError(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).parentPageMovedErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).parentPageMovedErrorDescription
    };
    else if ($dfcefa6efd7a826f$var$isInvalidParentError(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).invalidParentErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).invalidParentErrorDescription
    };
    else if ((0, $1uFM6.isUnauthorizedError)(error)) return {
        title: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).permissionRemovedErrorTitle,
        description: (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).permissionRemovedErrorDescription
    };
    return null;
};
const $dfcefa6efd7a826f$var$fireFlagActionClickedAnalytics = ({ createAnalyticsEvent: createAnalyticsEvent, template: template })=>{
    createAnalyticsEvent?.({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'link',
            actionSubjectId: 'redirectToDatabase',
            source: 'editorComponent',
            attributes: {
                flow: 'inlineDatabaseCreation',
                contentType: 'database',
                collabService: 'canvas-relay',
                templateType: template?.type,
                templateLayout: template?.layout
            }
        }
    }).fire();
};
const $dfcefa6efd7a826f$export$c063c49e521623c3 = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, flags: flags, template: template })=>{
    return async ()=>{
        try {
            experienceTracker?.start({
                name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).CREATE_CONTENT,
                attributes: {
                    flow: 'inlinePageCreation'
                }
            });
            // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
            const mutationResult = await (0, $hp2SH.getApolloClient)().mutate({
                mutation: (0, $87d59ca675d7b4ec$export$94bf7b80e41f7d2b),
                variables: {
                    createdInContentId: pageId,
                    spaceKey: spaceKey
                }
            });
            const { id: contentId } = mutationResult.data.createContentInline;
            if (template) {
                // canvas/database uses this to determine which template to apply
                // this would be more ideal to handle through stream hub events during the CreateContentInlineMutation, but we needed a quick and dirty solution
                (0, $c4TO3.AtlBrowserStorageLocal).setItem($dfcefa6efd7a826f$var$LS_DB_TEMPLATE_KEY, JSON.stringify({
                    templateLayout: template.layout,
                    templateType: template.type,
                    contentId: contentId
                }));
                // to help alleviate edge cases where user navigates away before db creation completes and canvas removes the local storage entry
                setTimeout(()=>{
                    (0, $c4TO3.AtlBrowserStorageLocal).removeItem($dfcefa6efd7a826f$var$LS_DB_TEMPLATE_KEY);
                }, $dfcefa6efd7a826f$export$d1ce03628c550fb);
            }
            createAnalyticsEvent?.({
                type: 'sendTrackEvent',
                data: {
                    actionSubject: 'content',
                    action: 'createdByFlow',
                    objectId: contentId,
                    objectType: 'database',
                    containerId: spaceId,
                    containerType: 'space',
                    source: 'editorComponent',
                    attributes: {
                        flow: 'inlineDatabaseCreation',
                        contentType: 'database',
                        collabService: 'canvas-relay',
                        templateType: template?.type,
                        templateLayout: template?.layout
                    }
                }
            }).fire();
            const fullUrl = $dfcefa6efd7a826f$export$b51cf6ef6d0676bd(contentId, spaceKey);
            await flags?.showFlag({
                type: 'success-circle',
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagTitle),
                actions: [
                    {
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagAction),
                        href: fullUrl,
                        target: '_blank',
                        onClick: ()=>$dfcefa6efd7a826f$var$fireFlagActionClickedAnalytics({
                                createAnalyticsEvent: createAnalyticsEvent,
                                template: template
                            })
                    }
                ],
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).successFlagDescription)
            });
            experienceTracker?.succeed({
                name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE)
            });
            return {
                type: 'embedCard',
                attrs: {
                    url: fullUrl
                }
            };
        } catch (error) {
            // only do this on error instead of finally, canvas/database will handle cleanup on success
            (0, $c4TO3.AtlBrowserStorageLocal).removeItem($dfcefa6efd7a826f$var$LS_DB_TEMPLATE_KEY);
            const cteTraceId = (0, $jn9ek.getTraceIdFromApolloError)(error);
            const expectedErrorMessage = $dfcefa6efd7a826f$export$56cb25c20f68202b(error);
            if (expectedErrorMessage) {
                experienceTracker?.succeed({
                    name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                    attributes: {
                        abortReason: 'expectedErrorMessage'
                    }
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), expectedErrorMessage.title),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), expectedErrorMessage.description)
                });
            } else {
                (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).DATABASES
                });
                experienceTracker?.stopOnError({
                    name: (0, $irVI7.CREATE_DATABASE_EXPERIENCE),
                    error: error,
                    attributes: {
                        cteTraceId: cteTraceId
                    }
                });
                await flags?.showErrorFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).defaultErrorFlagTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $7c2c9699294e7927$export$a7357cdd1f0b0168).defaultErrorFlagDescription)
                });
            }
            (0, $7Sm4c.markErrorAsHandled)(error);
        }
    };
};
const $dfcefa6efd7a826f$export$b51cf6ef6d0676bd = (contentId, spaceKey)=>{
    const databaseUrl = (0, $1NBp8.DATABASE_VIEW).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    return window.location.origin + databaseUrl;
};
const $dfcefa6efd7a826f$export$3fddcebfd1fcb0f5 = (intl)=>{
    return async ()=>{
        const el = document.createElement('div');
        document.body.appendChild(el);
        const sessionData = await (0, $ge2sX.getSessionData)();
        let result;
        try {
            result = await new Promise((resolve)=>{
                // eslint-disable-next-line react/no-deprecated
                (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).render(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                    value: sessionData
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dc4f221a49e0d4ac$export$8480276ebb3b339b), {
                    onClose: async (result)=>{
                        resolve(result);
                    },
                    intl: intl
                })), el);
            });
        } finally{
            // eslint-disable-next-line react/no-deprecated
            (0, (/*@__PURE__*/$parcel$interopDefault($jTxSS))).unmountComponentAtNode(el);
            document.body.removeChild(el);
        }
        if (result) return {
            type: 'embedCard',
            attrs: {
                url: result
            }
        };
        else return;
    };
};
const $dfcefa6efd7a826f$var$getPriority = ()=>{
    switch((0, $6mKj3.expVal)('cc_fd_wb_create_priority_in_slash_menu_experiment', 'cohort', 'control')){
        case 'wb_first':
            return -100;
        case 'db_first':
            return -300;
        default:
            return undefined;
    }
};
const $dfcefa6efd7a826f$var$getDatabaseIcon = (intl)=>{
    // when cleaning up the experiment, can productionalize the DatabaseIcon
    return (0, $6mKj3.UNSAFE_expValNoExposure)('cc_fd_db_quick_insert_options', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))), {
        label: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).createDatabaseIconAltText)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($bc87b26567284590$exports))),
        alt: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).createDatabaseIconAltText)
    });
};
const $dfcefa6efd7a826f$var$getQuickInsertItemsForPage = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, intl: intl, flags: flags })=>{
    const items = [
        {
            key: 'create-database',
            title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).createDatabaseTitle),
            description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).createDatabaseDescription),
            priority: $dfcefa6efd7a826f$var$getPriority(),
            icon: async ()=>()=>$dfcefa6efd7a826f$var$getDatabaseIcon(intl),
            action: $dfcefa6efd7a826f$export$c063c49e521623c3({
                pageId: pageId,
                spaceKey: spaceKey,
                spaceId: spaceId,
                experienceTracker: experienceTracker,
                createAnalyticsEvent: createAnalyticsEvent,
                flags: flags
            })
        }
    ];
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    if ((0, $6mKj3.UNSAFE_expValNoExposure)('cc_fd_db_quick_insert_options', 'isEnabled', false)) {
        const createDatabaseProps = {
            pageId: pageId,
            spaceKey: spaceKey,
            spaceId: spaceId,
            experienceTracker: experienceTracker,
            createAnalyticsEvent: createAnalyticsEvent,
            flags: flags
        };
        items.push({
            key: 'create-database-board-layout',
            title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseBoardLayoutTitle),
            description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseBoardLayoutDescription),
            icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5aaqS))), {
                        label: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseBoardLayoutIconAltText)
                    }),
            action: $dfcefa6efd7a826f$export$c063c49e521623c3({
                ...createDatabaseProps,
                template: {
                    layout: 'board',
                    type: 'simpleDatabase'
                }
            })
        }, {
            key: 'create-database-gallery-layout',
            title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseGalleryLayoutTitle),
            description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseGalleryLayoutDescription),
            icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dk0le))), {
                        label: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseGalleryLayoutIconAltText)
                    }),
            action: $dfcefa6efd7a826f$export$c063c49e521623c3({
                ...createDatabaseProps,
                template: {
                    layout: 'gallery',
                    type: 'simpleDatabase'
                }
            })
        }, {
            key: 'create-database-table-layout',
            title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseTableLayoutTitle),
            description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseTableLayoutDescription),
            icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ymSL))), {
                        label: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).databaseTableLayoutIconAltText)
                    }),
            action: $dfcefa6efd7a826f$export$c063c49e521623c3({
                ...createDatabaseProps,
                template: {
                    layout: 'table',
                    type: 'simpleDatabase'
                }
            })
        });
    }
    return items;
};
const $dfcefa6efd7a826f$export$f86f9e9c7cf6f650 = ({ pageId: pageId, spaceKey: spaceKey, spaceId: spaceId, intl: intl, flags: flags, experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, contentType: contentType, allowDatabaseQuickInsert: allowDatabaseQuickInsert, isEdit: isEdit })=>{
    const quickInsert = [];
    if (contentType === 'page') quickInsert.push(...$dfcefa6efd7a826f$var$getQuickInsertItemsForPage({
        pageId: pageId,
        spaceKey: spaceKey,
        spaceId: spaceId,
        experienceTracker: experienceTracker,
        createAnalyticsEvent: createAnalyticsEvent,
        intl: intl,
        flags: flags
    }));
    quickInsert.push({
        key: 'reference-database',
        title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseTitle),
        description: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseDescription),
        icon: async ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c7f5a98f0ee5cc1e$exports))),
                    alt: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).referenceDatabaseIconAltText)
                }),
        action: $dfcefa6efd7a826f$export$3fddcebfd1fcb0f5(intl)
    });
    return {
        title: intl.formatMessage((0, $7c2c9699294e7927$export$a7357cdd1f0b0168).manifestTitle),
        type: 'com.atlassian.confluence.macro.core',
        key: 'database-extension',
        icons: {
            '48': async ()=>()=>$dfcefa6efd7a826f$var$getDatabaseIcon(intl)
        },
        modules: {
            quickInsert: allowDatabaseQuickInsert ? quickInsert : [],
            nodes: {
                default: {
                    type: 'inlineExtension',
                    render: async ()=>{
                        const sessionData = await (0, $ge2sX.getSessionData)();
                        return ({ node: node })=>{
                            const contentId = node.parameters?.macroParams?.contentId.value;
                            const entryId = node.parameters?.macroParams?.entryId.value;
                            const fieldId = node.parameters?.macroParams?.fieldId.value;
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7i8j.SessionDataContext).Provider, {
                                value: sessionData
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e75add8c1d946f03$export$df287bda027f951a), {
                                contentId: contentId,
                                fieldId: fieldId,
                                entryId: entryId,
                                isEdit: isEdit
                            }));
                        };
                    }
                }
            }
        }
    };
};
module.exports["getFullDatabaseUrl"] = $dfcefa6efd7a826f$export$b51cf6ef6d0676bd;
module.exports["createDatabaseExtension"] = $dfcefa6efd7a826f$export$f86f9e9c7cf6f650;

});

parcelRegister("9Eka4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ibzAc = parcelRequire("ibzAc");


var $f8eu7 = parcelRequire("f8eu7");

var $l1vR8 = parcelRequire("l1vR8");

var $1RH0O = parcelRequire("1RH0O");


var $inPa6 = parcelRequire("inPa6");


var $477dG = parcelRequire("477dG");


var $l998X = parcelRequire("l998X");





var $d925B = parcelRequire("d925B");


var $7fmpI = parcelRequire("7fmpI");


var $gtauf = parcelRequire("gtauf");

var $lEQpi = parcelRequire("lEQpi");


var $dh538 = parcelRequire("dh538");




parcelRequire("42omo");


var $e6n00 = parcelRequire("e6n00");


var $awHlv = parcelRequire("awHlv");

var $a7tZV = parcelRequire("a7tZV");


var $keGcB = parcelRequire("keGcB");


var $bEEXh = parcelRequire("bEEXh");


var $1Wy2j = parcelRequire("1Wy2j");

const $97d9ff76fb12c778$export$da661eaac6059c75 = ({ nodeProps: nodeProps, syncBlockStoreManager: syncBlockStoreManager, rendererOptions: rendererOptions })=>{
    const { resourceId: resourceId, localId: localId, fireAnalyticsEvent: fireAnalyticsEvent } = nodeProps;
    syncBlockStoreManager.referenceManager.updateFireAnalyticsEvent(fireAnalyticsEvent);
    const { syncBlockInstance: syncBlockInstance, isLoading: isLoading, reloadData: reloadData, providerFactory: providerFactory } = (0, $a7tZV.useFetchSyncBlockData)(syncBlockStoreManager, resourceId, localId, fireAnalyticsEvent);
    if (isLoading && !syncBlockInstance) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1Wy2j.SyncedBlockLoadingState), {});
    if (!resourceId || syncBlockInstance?.error || !syncBlockInstance?.data) return /*#__PURE__*/ (0, $l998X.jsx)((0, $bEEXh.SyncedBlockErrorComponent), {
        error: syncBlockInstance?.error ?? (0, $awHlv.SyncBlockError).Errored,
        resourceId: syncBlockInstance?.resourceId,
        onRetry: reloadData,
        isLoading: isLoading,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    const syncBlockDoc = {
        content: syncBlockInstance.data.content,
        version: 1,
        type: 'doc'
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $e6n00.SyncBlockSharedCssClassName).renderer,
        [(0, $e6n00.SyncBlockRendererDataAttributeName)]: true,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $keGcB.AKRendererWrapper), {
            doc: syncBlockDoc,
            dataProviders: providerFactory,
            options: rendererOptions
        })
    });
};


const $eb2b1125b5abca94$export$28a555a4d57f5843 = (doc)=>{
    const { content: content } = doc;
    const isEmpty = !content || !Array.isArray(content) || content.length === 0;
    const syncBlockNodes = isEmpty ? [] : content.map((node)=>(0, $gtauf.convertSyncBlockJSONNodeToSyncBlockNode)(node)).filter((node)=>node !== undefined);
    return syncBlockNodes;
};
const $eb2b1125b5abca94$export$2813820533ed0641 = ({ syncBlockNodes: syncBlockNodes, syncBlockProvider: syncBlockProvider, syncBlockRendererOptions: syncBlockRendererOptions, fireAnalyticsEvent: fireAnalyticsEvent, getSSRData: getSSRData })=>{
    const syncBlockStoreManager = (0, $lEQpi.useMemoizedSyncBlockStoreManager)(syncBlockProvider, fireAnalyticsEvent);
    // Initialize SSR data if available
    (0, $42omo.useEffect)(()=>{
        if (getSSRData && (0, $dh538.fg)('platform_synced_block_dogfooding')) {
            const ssrData = getSSRData();
            if (ssrData && syncBlockProvider.setSSRData) syncBlockProvider.setSSRData(ssrData);
        }
    }, [
        getSSRData,
        syncBlockProvider
    ]);
    // Initial fetch sync block data (will use SSR data as initial cache if available)
    (0, $42omo.useEffect)(()=>{
        syncBlockStoreManager.referenceManager.fetchSyncBlocksData(syncBlockNodes);
    }, [
        syncBlockNodes,
        syncBlockStoreManager.referenceManager
    ]);
    return (0, $42omo.useCallback)((props)=>(0, $dh538.fg)('platform_synced_block_dogfooding') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $7fmpI.ErrorBoundary), {
            component: (0, $d925B.ACTION_SUBJECT).SYNCED_BLOCK,
            dispatchAnalyticsEvent: fireAnalyticsEvent,
            fallbackComponent: null,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $97d9ff76fb12c778$export$da661eaac6059c75), {
                nodeProps: props,
                syncBlockStoreManager: syncBlockStoreManager,
                rendererOptions: syncBlockRendererOptions
            }, props.localId)
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $97d9ff76fb12c778$export$da661eaac6059c75), {
            nodeProps: props,
            syncBlockStoreManager: syncBlockStoreManager,
            rendererOptions: syncBlockRendererOptions
        }, props.localId), [
        syncBlockStoreManager,
        syncBlockRendererOptions,
        fireAnalyticsEvent
    ]);
};



var $k00oi = parcelRequire("k00oi");


var $dTb09 = parcelRequire("dTb09");


var $jQQYu = parcelRequire("jQQYu");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $4IoVL = parcelRequire("4IoVL");


var $iP9x4 = parcelRequire("iP9x4");


var $60cDW = parcelRequire("60cDW");


var $32x2E = parcelRequire("32x2E");


var $epn2u = parcelRequire("epn2u");


var $9wGTI = parcelRequire("9wGTI");

const $4a3ff359f5c9274c$export$6af91131bd465ca7 = (cloudId, userId)=>{
    return (0, $42omo.useMemo)(()=>({
            createEmojiProvider: ()=>{
                return (0, $32x2E.getEmojiProvider)((0, $ibzAc.default), {
                    cloudId: cloudId,
                    userId: userId || undefined,
                    allowAnonymousAccess: true
                });
            },
            createMediaProvider: ({ contentId: refSyncBlockContentId })=>{
                return (0, $4IoVL.createRendererMediaProvider)({
                    contentId: refSyncBlockContentId,
                    isExternalShare: false
                });
            },
            createSSRMediaProvider: ({ contentId: refSyncBlockContentId })=>{
                if (!(0, $9wGTI.fg)('platform_synced_block_dogfooding')) return undefined;
                const mediaClientConfig = (0, $iP9x4.getMediaSSRModeAndAuthConfigMemoized)({
                    contentId: refSyncBlockContentId,
                    isExternalShare: false
                });
                if (mediaClientConfig?.mode === 'server') return {
                    viewMediaClientConfig: mediaClientConfig.config
                };
                return undefined;
            },
            // Uses the same logic as in preloadEditorNodeDataProvidersData.ts
            createSmartLinkProvider: ()=>{
                const { host: host, cloudId: ssrCloudId, userContext: userContext, customURLs: customURLs } = (0, $60cDW.getSSRRenderInputs)();
                const objectResolverURL = customURLs?.['object-resolver-service']?.match(/^(https?:\/\/[^/]+)/)?.[0];
                if (objectResolverURL) {
                    const ssrCardClient = new (0, $k00oi.default)('custom', objectResolverURL);
                    ssrCardClient.setHeaders({
                        Cookie: (0, $jQQYu.createCookie)(userContext),
                        Origin: host.startsWith('http') ? host : `https://${host}`,
                        CloudId: ssrCloudId || cloudId
                    });
                    return Promise.resolve(new (0, $477dG.EditorCardProvider)('custom', objectResolverURL, 'CONFLUENCE', undefined, ssrCardClient));
                }
                return Promise.resolve(new (0, $477dG.EditorCardProvider)());
            }
        }), [
        cloudId,
        userId
    ]);
};
const $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled = ({ doc: doc, contentId: confluencePageId, contentType: contentType, mergedDataProviderDefinitions: mergedDataProviderDefinitions })=>{
    const syncBlockNodes = (0, $42omo.useMemo)(()=>{
        return (0, $eb2b1125b5abca94$export$28a555a4d57f5843)(doc);
    }, [
        doc
    ]);
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const confluencePageAri = (0, $42omo.useMemo)(()=>confluencePageId ? (0, $f8eu7.getConfluencePageAri)({
            pageId: confluencePageId,
            cloudId: cloudId,
            pageType: contentType === 'page' ? 'page' : 'blogpost'
        }) : undefined, [
        cloudId,
        confluencePageId,
        contentType
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { fetchProvider: blockServiceFetchProvider, writeProvider: blockServiceWriteProvider } = (0, $l1vR8.useMemoizedBlockServiceAPIProviders)({
        parentAri: confluencePageAri ?? '',
        parentId: confluencePageId ?? '',
        product: 'confluence-page',
        cloudId: cloudId
    });
    const syncedBlockNestedRendererProviderCreator = $4a3ff359f5c9274c$export$6af91131bd465ca7(cloudId, userId);
    const providerOptions = (0, $42omo.useMemo)(()=>{
        return {
            parentDataProviders: {
                ...mergedDataProviderDefinitions
            },
            providerCreator: syncedBlockNestedRendererProviderCreator
        };
    }, [
        mergedDataProviderDefinitions,
        syncedBlockNestedRendererProviderCreator
    ]);
    const syncedBlockProvider = (0, $1RH0O.useMemoizedSyncedBlockProvider)({
        fetchProvider: blockServiceFetchProvider,
        writeProvider: blockServiceWriteProvider,
        providerOptions: providerOptions,
        getSSRData: (0, $epn2u.syncedBlockLoadSSRData)
    });
    const handleSyncedBlockAnalyticsEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: payload
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const SyncedBlockNodeComponent = (0, $eb2b1125b5abca94$export$2813820533ed0641)({
        syncBlockProvider: syncedBlockProvider,
        syncBlockNodes: syncBlockNodes,
        syncBlockRendererOptions: {
            smartLinks: {
                ssr: true
            }
        },
        fireAnalyticsEvent: handleSyncedBlockAnalyticsEvent,
        getSSRData: (0, $epn2u.syncedBlockLoadSSRData)
    });
    // If confluencePageId is undefined, don't return the synced block node component, and don't render synced blocks
    return confluencePageId ? SyncedBlockNodeComponent : undefined;
};
const $4a3ff359f5c9274c$export$27db3e01691a7a01 = (_props)=>{
    return undefined;
};
const $4a3ff359f5c9274c$export$e8874f89f60efbe6 = (0, $dTb09.conditionalHooksFactory)(()=>(0, $6mKj3.isExperimentEnabled)('platform_synced_block'), $4a3ff359f5c9274c$var$useMemoizedSyncedBlockProviderNodeComponentEnabled, $4a3ff359f5c9274c$export$27db3e01691a7a01);
module.exports["useMemoizedSyncedBlockNestedRendererProviderCreator"] = $4a3ff359f5c9274c$export$6af91131bd465ca7;
module.exports["useMemoizedSyncedBlockProviderNodeComponent"] = $4a3ff359f5c9274c$export$e8874f89f60efbe6;

});

parcelRegister("1RH0O", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $ejAeh = parcelRequire("ejAeh");


var $f8eu7 = parcelRequire("f8eu7");

/* eslint-disable require-unicode-regexp  */ 
var $hWRJP = parcelRequire("hWRJP");





var $cFpEg = parcelRequire("cFpEg");


var $k2in1 = parcelRequire("k2in1");




const $561b091c9fc9d97e$export$b0f71b2573c0c248 = (pageType)=>{
    return pageType === 'blogpost';
};


const $03df2d74a364c2ee$var$COMMON_HEADERS = {
    'Content-Type': 'application/json',
    Accept: 'application/json'
};
const $03df2d74a364c2ee$var$AGG_HEADERS = {
    'X-ExperimentalApi': 'confluence-agg-beta'
};
const $03df2d74a364c2ee$var$GRAPHQL_ENDPOINT = '/gateway/api/graphql';
const $03df2d74a364c2ee$var$GET_SOURCE_INFO_OPERATION_NAME = 'EDITOR_SYNCED_BLOCK_GET_SOURCE_INFO';
/**
 * Query to get the page subtype by id (i.e. live or classic)
 * @param documentARI
 * @returns subType live if livePage, subType null if classic page
 */ const $03df2d74a364c2ee$var$GET_SOURCE_INFO_QUERY = `query ${$03df2d74a364c2ee$var$GET_SOURCE_INFO_OPERATION_NAME} ($id: ID!) {
	content (id: $id) {
		nodes {
			id
			links {
				base
			}
			space {
				key
			}
			subType
			title
		}
	}
}`;
const $03df2d74a364c2ee$var$getConfluenceSourceInfo = async (ari)=>{
    const bodyData = {
        query: $03df2d74a364c2ee$var$GET_SOURCE_INFO_QUERY,
        operationName: $03df2d74a364c2ee$var$GET_SOURCE_INFO_OPERATION_NAME,
        variables: {
            id: ari
        }
    };
    const response = await (0, $k2in1.fetchWithRetry)($03df2d74a364c2ee$var$GRAPHQL_ENDPOINT, {
        method: 'POST',
        headers: {
            ...$03df2d74a364c2ee$var$COMMON_HEADERS,
            ...$03df2d74a364c2ee$var$AGG_HEADERS
        },
        body: JSON.stringify(bodyData)
    });
    if (!response.ok) throw new Error(`Failed to get url: ${response.statusText}`);
    return await response.json();
};
const $03df2d74a364c2ee$var$resolveNoAccessPageInfo = async (ari)=>{
    const response = await fetch('/gateway/api/object-resolver/resolve/ari', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            ari: ari
        })
    });
    if (response.ok) {
        const payload = await response.json();
        const url = payload?.data?.url;
        const title = payload?.data?.name;
        return {
            url: typeof url === 'string' ? url : undefined,
            title: typeof title === 'string' ? title : undefined,
            sourceAri: ari
        };
    } else throw new Error(`Failed to resolve ari: ${response.statusText}`);
};
const $03df2d74a364c2ee$export$f4cbe2260d1da651 = async (pageAri, localId, fireAnalyticsEvent)=>{
    try {
        const { type: pageType } = (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
            ari: pageAri
        });
        const response = await $03df2d74a364c2ee$var$getConfluenceSourceInfo(pageAri);
        const contentData = response.data?.content?.nodes?.[0];
        const title = contentData?.title;
        let url;
        const { base: base } = contentData?.links || {};
        if (base && contentData?.space?.key && contentData?.id) {
            if ((0, $561b091c9fc9d97e$export$b0f71b2573c0c248)(pageType)) url = `${base}/spaces/${contentData.space.key}/blog/edit-v2/${contentData.id}`;
            else if (contentData.subType === 'live') url = `${base}/spaces/${contentData.space.key}/pages/${contentData.id}`;
            else url = `${base}/spaces/${contentData.space.key}/pages/edit-v2/${contentData.id}`;
        }
        url = url && localId ? `${url}#block-${localId}` : url;
        if (!title || !url) fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)('Failed to get confluence page source info'));
        return Promise.resolve({
            title: title,
            url: url,
            sourceAri: pageAri
        });
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-synced-block-provider/sourceInfo'
        });
        fireAnalyticsEvent?.((0, $cFpEg.getSourceInfoErrorPayload)(error.message));
        return Promise.resolve(undefined);
    }
};
const $03df2d74a364c2ee$export$b4d6375feea1e587 = async (pageAri, hasAccess, urlType, localId)=>{
    if (hasAccess) {
        const { type: pageType } = (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
            ari: pageAri
        });
        const response = await $03df2d74a364c2ee$var$getConfluenceSourceInfo(pageAri);
        const contentData = response.data?.content?.nodes?.[0];
        const { title: title, subType: subType } = contentData || {};
        let url;
        const { base: base } = contentData?.links || {};
        if (base && contentData?.space?.key && contentData?.id) {
            if ((0, $561b091c9fc9d97e$export$b0f71b2573c0c248)(pageType)) url = `${base}/spaces/${contentData.space.key}/blog${urlType === 'edit' ? '/edit-v2' : ''}/${contentData.id}`;
            else if (contentData.subType === 'live') url = `${base}/spaces/${contentData.space.key}/pages/${contentData.id}`;
            else url = `${base}/spaces/${contentData.space.key}/pages${urlType === 'edit' ? '/edit-v2' : ''}/${contentData.id}`;
        }
        url = url && localId ? `${url}#block-${localId}` : url;
        return Promise.resolve({
            title: title,
            url: url,
            sourceAri: pageAri,
            subType: subType
        });
    } else return await $03df2d74a364c2ee$var$resolveNoAccessPageInfo(pageAri);
};
const $03df2d74a364c2ee$export$11ee05f70c94d3d7 = async (pageAri, hasAccess, urlType, localId, fireAnalyticsEvent)=>{
    return (0, $dh538.fg)('platform_synced_block_dogfooding') ? await $03df2d74a364c2ee$export$b4d6375feea1e587(pageAri, hasAccess, urlType, localId) : await $03df2d74a364c2ee$export$f4cbe2260d1da651(pageAri, localId, fireAnalyticsEvent);
};



var $awHlv = parcelRequire("awHlv");


var $i0VEL = parcelRequire("i0VEL");

class $fc26c56016d8bd54$export$dd1cc50ea374801e extends (0, $i0VEL.NodeDataProvider) {
}


class $082ae0f64f625fc6$export$86215bf52ddaa76d extends (0, $fc26c56016d8bd54$export$dd1cc50ea374801e) {
    setProviderOptions(providerOptions) {
        this.providerOptions = providerOptions;
    }
    /**
   * Check if the node is supported by the provider
   *
   * @param node
   *
   * @returns True if the node is supported, false otherwise
   */ isNodeSupported(node) {
        return node.type === 'syncBlock' || node.type === 'bodiedSyncBlock';
    }
    /**
   * Get the data key for the node
   *
   * @param node
   *
   * @returns The data key
   */ nodeDataKey(node) {
        return node.attrs.resourceId;
    }
    /**
   * Fetch the data from the fetch provider using batch API
   *
   * @param nodes
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async fetchNodesData(nodes) {
        const blockIdentifiers = nodes.map((node)=>({
                resourceId: node.attrs.resourceId,
                blockInstanceId: node.attrs.localId
            }));
        if (blockIdentifiers.length === 0) return [];
        if ((0, $dh538.fg)('platform_synced_block_dogfooding')) try {
            return await this.fetchProvider.batchFetchData(blockIdentifiers);
        } catch  {
            // If batch fetch fails, fall back to individual fetch behavior
            // This allows loading states to be shown before errors, matching non-batch behavior
            return Promise.allSettled(blockIdentifiers.map((blockIdentifier)=>{
                return this.fetchProvider.fetchData(blockIdentifier.resourceId).then((data)=>{
                    return data;
                }, ()=>{
                    return {
                        error: (0, $awHlv.SyncBlockError).Errored,
                        resourceId: blockIdentifier.resourceId
                    };
                });
            })).then((results)=>{
                return results.filter((result)=>{
                    return result.status === 'fulfilled';
                }).map((result)=>result.value);
            });
        }
        else return Promise.allSettled(blockIdentifiers.map((blockIdentifier)=>{
            return this.fetchProvider.fetchData(blockIdentifier.resourceId).then((data)=>{
                return data;
            }, ()=>{
                return {
                    error: (0, $awHlv.SyncBlockError).Errored,
                    resourceId: blockIdentifier.resourceId
                };
            });
        })).then((results)=>{
            return results.filter((result)=>{
                return result.status === 'fulfilled';
            }).map((result)=>result.value);
        });
    }
    /**
   * Write the data to the write provider
   *
   * @param nodes
   * @param data
   *
   * @returns Array of {resourceId?: string, error?: string}.
   * resourceId: resource id of the node if write successfully , error: reason for when write failed
   */ async writeNodesData(nodes, data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        const results = await Promise.allSettled(nodes.map((_node, index)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            if (!data[index].content) return Promise.reject('No Synced Block content to write');
            return this.writeProvider?.writeData(data[index]);
        }));
        return results.map((result)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                error: result.reason
            };
        });
    }
    createNodeData(data) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        return this.writeProvider.createData(data).then((result)=>result, (error)=>({
                error: error
            }));
    }
    /**
   * Delete the data from the write provider
   *
   * @param resourceIds
   *
   * @returns Array of {resourceId?: string, error?: string}.
   */ async deleteNodesData(resourceIds) {
        if (!this.writeProvider) return Promise.reject(new Error('Write provider not set'));
        const results = await Promise.allSettled(resourceIds.map((resourceId)=>{
            if (!this.writeProvider) return Promise.reject('Write provider not set');
            return this.writeProvider.deleteData(resourceId);
        }));
        return results.map((result, index)=>{
            if (result.status === 'fulfilled') return result.value;
            else return {
                resourceId: resourceIds[index],
                success: false,
                error: result.reason
            };
        });
    }
    /**
   * Fetch the source info from the source id
   *
   * @param params
   * @param params.sourceAri - The source ARI
   * @param params.sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The source info
   */ async fetchSyncBlockSourceInfo(localId, sourceAri, sourceProduct, fireAnalyticsEvent, hasAccess = true, urlType = 'edit') {
        let ari = sourceAri, product = sourceProduct;
        if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
            ari = sourceAri ?? this.writeProvider?.parentAri;
            product = sourceProduct ?? (0, $ejAeh.getProductFromSourceAri)(ari);
        }
        if (!ari || !product) return Promise.reject(new Error('Source ari or source product is undefined'));
        switch(product){
            case 'confluence-page':
                {
                    const sourceInfo = await (0, $03df2d74a364c2ee$export$11ee05f70c94d3d7)(ari, hasAccess, urlType, localId, fireAnalyticsEvent);
                    if ((0, $dh538.fg)('platform_synced_block_dogfooding')) {
                        if (!sourceInfo) return Promise.resolve(undefined);
                        return {
                            ...sourceInfo,
                            onSamePage: this.writeProvider?.parentAri === ari,
                            productType: product
                        };
                    } else return sourceInfo;
                }
            case 'jira-work-item':
                if ((0, $dh538.fg)('platform_synced_block_dogfooding')) return Promise.resolve(undefined);
                return Promise.reject(new Error('Jira work item source product not supported'));
            default:
                return Promise.reject(new Error(`${product} source product not supported`));
        }
    }
    generateResourceId() {
        const localId = crypto.randomUUID();
        const resourceId = crypto.randomUUID();
        return {
            localId: localId,
            resourceId: resourceId
        };
    }
    generateResourceIdForReference(sourceId) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.generateResourceIdForReference(sourceId);
    }
    /**
   * Get the synced block renderer provider options
   *
   * @returns The synced block renderer provider options
   */ getSyncedBlockRendererProviderOptions() {
        return this.providerOptions;
    }
    /**
   * Retrieve the parent info for the sync block
   *
   * @param sourceAri - The source ARI
   * @param sourceProduct - The source product. e.g. 'confluence-page', 'jira-work-item'
   *
   * @returns The parent info for the sync block
   */ retrieveSyncBlockParentInfo(sourceAri, sourceProduct) {
        if (!sourceAri || !sourceProduct) return undefined;
        switch(sourceProduct){
            case 'confluence-page':
                return {
                    contentId: (0, $f8eu7.getPageIdAndTypeFromConfluencePageAri)({
                        ari: sourceAri
                    }).id,
                    contentProduct: sourceProduct
                };
            case 'jira-work-item':
                throw new Error('Jira work item source product not supported');
            default:
                throw new Error(`${sourceProduct} source product not supported`);
        }
    }
    updateReferenceData(blocks, noContent) {
        if (!this.writeProvider) throw new Error('Write provider not set');
        return this.writeProvider.updateReferenceData(blocks, noContent);
    }
    fetchReferences(resourceId, isSource) {
        if (!this.fetchProvider) throw new Error('Fetch provider not set');
        return this.fetchProvider.fetchReferences(isSource ? this.generateResourceIdForReference(resourceId) : resourceId);
    }
    /**
   * Constructor for the SyncBlockProvider
   *
   * @param fetchProvider
   * @param writeProvider
   * @param nestedRendererDataProviders
   */ constructor(fetchProvider, writeProvider){
        super();
        this.name = 'syncBlockProvider';
        this.fetchProvider = void 0;
        this.writeProvider = void 0;
        this.providerOptions = void 0;
        this.fetchProvider = fetchProvider;
        this.writeProvider = writeProvider;
        this.providerOptions = {};
    }
}
const $082ae0f64f625fc6$var$createSyncedBlockProvider = ({ fetchProvider: fetchProvider, writeProvider: writeProvider })=>{
    return new $082ae0f64f625fc6$export$86215bf52ddaa76d(fetchProvider, writeProvider);
};
const $082ae0f64f625fc6$export$ae97d432056ca005 = ({ fetchProvider: fetchProvider, writeProvider: writeProvider, providerOptions: providerOptions, getSSRData: getSSRData })=>{
    const syncBlockProvider = (0, $42omo.useMemo)(()=>$082ae0f64f625fc6$var$createSyncedBlockProvider({
            fetchProvider: fetchProvider,
            writeProvider: writeProvider
        }), [
        fetchProvider,
        writeProvider
    ]);
    syncBlockProvider.setProviderOptions(providerOptions);
    const ssrData = getSSRData ? getSSRData() : undefined;
    if (ssrData) syncBlockProvider.setSSRData(ssrData);
    return syncBlockProvider;
};
module.exports["useMemoizedSyncedBlockProvider"] = $082ae0f64f625fc6$export$ae97d432056ca005;

});

parcelRegister("keGcB", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fzXn1 = parcelRequire("fzXn1");


var $hlcQd = parcelRequire("hlcQd");

var $67O0h = parcelRequire("67O0h");

var $iZq0X = parcelRequire("iZq0X");


var $lspPP = parcelRequire("lspPP");


var $3gadb = parcelRequire("3gadb");

const $a04998616bd329fd$var$ValidationContextWrapper = ({ children: children })=>{
    const validationContextValue = (0, $42omo.useMemo)(()=>({
            allowNestedTables: true
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iZq0X.ValidationContextProvider), {
        value: validationContextValue,
        children: children
    });
};
const $a04998616bd329fd$var$DisabledTaskWithTooltip = ({ componentKey: componentKey, ...props })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const tooltipContent = formatMessage((0, $fzXn1.syncBlockMessages).taskInDestinationSyncedBlockTooltip);
    const Component = (0, $hlcQd.nodeToReact)[componentKey];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltipContent,
        position: "auto-start",
        children: (tooltipProps)=>// eslint-disable-next-line react/jsx-props-no-spreading
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...props,
                    disableOnChange: true
                })
            })
    });
};
const $a04998616bd329fd$var$defaultOptions = {
    appearance: 'full-width',
    allowAltTextOnImages: true,
    allowAnnotations: true,
    allowColumnSorting: true,
    allowCopyToClipboard: true,
    allowCustomPanels: true,
    allowPlaceholderText: true,
    allowRendererContainerStyles: true,
    allowSelectAllTrap: true,
    allowUgcScrubber: true,
    allowWrapCodeBlock: true,
    emojiResourceConfig: undefined,
    media: {
        allowLinking: true,
        allowCaptions: true,
        featureFlags: {
            mediaInline: true
        }
    },
    smartLinks: {
        ssr: true
    }
};
const $a04998616bd329fd$export$cc2ec5e10e7ca244 = /*#__PURE__*/ (0, $42omo.memo)(({ doc: doc, dataProviders: dataProviders, options: options })=>{
    const mergedOptions = {
        ...$a04998616bd329fd$var$defaultOptions,
        ...options
    };
    const { appearance: appearance, allowAltTextOnImages: allowAltTextOnImages, allowAnnotations: allowAnnotations, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowCustomPanels: allowCustomPanels, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowRendererContainerStyles: allowRendererContainerStyles, allowSelectAllTrap: allowSelectAllTrap, allowUgcScrubber: allowUgcScrubber, allowWrapCodeBlock: allowWrapCodeBlock, emojiResourceConfig: emojiResourceConfig, media: media, smartLinks: smartLinks, stickyHeaders: stickyHeaders } = mergedOptions ?? {};
    const nodeComponents = (0, $42omo.useMemo)(()=>{
        return {
            taskItem: (props)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, $l998X.jsx)($a04998616bd329fd$var$DisabledTaskWithTooltip, {
                    componentKey: "taskItem",
                    ...props
                });
            },
            blockTaskItem: (props)=>{
                // eslint-disable-next-line react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, $l998X.jsx)($a04998616bd329fd$var$DisabledTaskWithTooltip, {
                    componentKey: "blockTaskItem",
                    ...props
                });
            }
        };
    }, []);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lspPP.RendererActionsContext), {
        children: /*#__PURE__*/ (0, $l998X.jsx)($a04998616bd329fd$var$ValidationContextWrapper, {
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": "sync-block-renderer-wrapper",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $67O0h.default), {
                    appearance: appearance,
                    adfStage: "stage0",
                    document: doc,
                    disableHeadingIDs: true,
                    dataProviders: dataProviders,
                    nodeComponents: nodeComponents,
                    allowAltTextOnImages: allowAltTextOnImages,
                    allowAnnotations: allowAnnotations,
                    allowColumnSorting: allowColumnSorting,
                    allowCopyToClipboard: allowCopyToClipboard,
                    allowCustomPanels: allowCustomPanels,
                    allowHeadingAnchorLinks: allowHeadingAnchorLinks,
                    allowPlaceholderText: allowPlaceholderText,
                    allowRendererContainerStyles: allowRendererContainerStyles,
                    allowSelectAllTrap: allowSelectAllTrap,
                    allowUgcScrubber: allowUgcScrubber,
                    allowWrapCodeBlock: allowWrapCodeBlock,
                    emojiResourceConfig: emojiResourceConfig,
                    media: media,
                    smartLinks: smartLinks,
                    stickyHeaders: stickyHeaders
                })
            })
        })
    });
});
module.exports["AKRendererWrapper"] = $a04998616bd329fd$export$cc2ec5e10e7ca244;

});

parcelRegister("bEEXh", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $hWRJP = parcelRequire("hWRJP");


var $e6n00 = parcelRequire("e6n00");


var $cFpEg = parcelRequire("cFpEg");

var $gtauf = parcelRequire("gtauf");

var $awHlv = parcelRequire("awHlv");




parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $fzXn1 = parcelRequire("fzXn1");

/* SyncedBlockErrorStateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $744ND = parcelRequire("744ND");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");

const $167b82dc4ac7f177$var$styles = {
    wrapper: "_zulppxbi _ca0qu2gc _n3tdu2gc _19bvpxbi _u5f3pxbi _1e0c1txw _1bahv2br _4cvr1h6o"
};
const $167b82dc4ac7f177$export$dc0ab13618635cb1 = ({ children: children, description: description })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $167b82dc4ac7f177$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($744ND))), {
                color: "var(--ds-icon-subtle, #505258)",
                label: ""
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                color: "color.text.subtle",
                children: description
            }),
            children
        ]
    });
};


const $f85682255cf077df$export$59b0b39f63011407 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: formatMessage((0, $fzXn1.syncBlockMessages).generalErrorDescription)
    });
};





parcelRequire("42omo");





var $ccHMk = parcelRequire("ccHMk");





const $5e5c198b585256f8$export$ca85b0be86ccfb26 = ({ onRetry: onRetry, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: formatMessage((0, $fzXn1.syncBlockMessages).generalErrorDescription),
        children: onRetry && /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
            appearance: "default",
            spacing: "compact",
            onClick: (event)=>{
                event.preventDefault();
                event.stopPropagation();
                onRetry();
            },
            isLoading: isLoading,
            testId: "sync-block-retry-btn",
            children: formatMessage((0, $fzXn1.syncBlockMessages).retryButton)
        })
    });
};





parcelRequire("42omo");








const $feacbaab62ed6a89$export$3f73b17e61025be6 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: formatMessage((0, $fzXn1.syncBlockMessages).notFoundDescription)
    });
};





parcelRequire("42omo");








const $9db02b4444c232ef$export$8a461f6033aecd80 = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $167b82dc4ac7f177$export$dc0ab13618635cb1), {
        description: formatMessage((0, $fzXn1.syncBlockMessages).offlineError)
    });
};





/**
 * @generated SignedSource<<3bfb9487e57255dc0512f225894a058b>>
 * @relayHash 676631e44ffd7d0d16b3a7e96ba02def
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d
const $81e8fecca2e99343$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "68a651ca7e5a5c9b5a075954ed948672c451b0f8c255f4edbd3219fe4947484d",
            "metadata": {},
            "name": "SyncedBlockPermissionDeniedRequestAccessMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$81e8fecca2e99343$var$node.hash = "d0d4982ad805583380d2436a8e21ee6a";
var $81e8fecca2e99343$export$2e2bcd8739ae039 = $81e8fecca2e99343$var$node;









var $irOoi = parcelRequire("irOoi");








var $cO1el = parcelRequire("cO1el");


var $3sFtD = parcelRequire("3sFtD");


var $gj7hi = parcelRequire("gj7hi");




var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");



var $682ccca673fecc9d$exports = {};
$682ccca673fecc9d$exports = new URL("PermissionDenied.bfcb6211.svg", import.meta.url).toString();



const $a081b56695b04c74$var$styles = {
    wrapper: "_zulppxbi _ca0qv47k _n3tdv47k _19bvv47k _u5f3v47k _1e0c1txw _1bahv2br _4cvr1h6o"
};
var $a081b56695b04c74$var$RequestAccessState = /*#__PURE__*/ function(RequestAccessState) {
    RequestAccessState["default"] = "default";
    RequestAccessState["errored"] = "errored";
    RequestAccessState["loading"] = "loading";
    RequestAccessState["pending"] = "pending";
    return RequestAccessState;
}($a081b56695b04c74$var$RequestAccessState || {});
const $a081b56695b04c74$var$SyncedBlockPermissionDeniedConfluencePage = ({ sourceContentId: sourceContentId })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [requestAccessState, setRequestAccessState] = (0, $42omo.useState)("default");
    const handleRequestComplete = ()=>{
        setRequestAccessState("pending");
    };
    const handleRequestError = ()=>{
        setRequestAccessState("errored");
    };
    const [commitMutation] = (0, $irOoi.useMutation)((0, $81e8fecca2e99343$export$2e2bcd8739ae039));
    const onClick = ()=>{
        setRequestAccessState("loading");
        commitMutation({
            variables: {
                requestPageAccessInput: {
                    pageId: sourceContentId,
                    accessType: 'VIEW'
                }
            },
            onCompleted: ()=>{
                handleRequestComplete();
            },
            onError: handleRequestError
        });
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
        xcss: $a081b56695b04c74$var$styles.wrapper,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($682ccca673fecc9d$exports))),
                alt: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedAltText),
                width: "48",
                height: "48"
            }),
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                        size: "xsmall",
                        children: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedHeading)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: "color.text.subtle",
                        children: formatMessage((0, $fzXn1.syncBlockMessages).permissionDeniedDescription)
                    }),
                    requestAccessState === "pending" ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        columnGap: "space.050",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
                                size: "small",
                                color: "var(--ds-icon-subtle, #505258)",
                                label: ""
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.subtlest",
                                weight: "bold",
                                testId: "sync-block-access-requested-msg",
                                children: formatMessage((0, $fzXn1.syncBlockMessages).accessRequested)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                        columnGap: "space.100",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                                appearance: "default",
                                spacing: "compact",
                                onClick: onClick,
                                isLoading: requestAccessState === "loading",
                                testId: "sync-block-request-access-btn",
                                children: formatMessage((0, $fzXn1.syncBlockMessages).requestAccessButton)
                            }),
                            requestAccessState === "errored" && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                color: "color.text.warning",
                                testId: "sync-block-access-error-msg",
                                children: formatMessage((0, $fzXn1.syncBlockMessages).requestAccessError)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $a081b56695b04c74$export$33325aff698460b9 = ({ sourceContentId: sourceContentId, sourceProduct: sourceProduct })=>{
    switch(sourceProduct){
        case 'confluence-page':
            return /*#__PURE__*/ (0, $l998X.jsx)($a081b56695b04c74$var$SyncedBlockPermissionDeniedConfluencePage, {
                sourceContentId: sourceContentId
            });
        default:
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $f85682255cf077df$export$59b0b39f63011407), {});
    }
};


const $ea1f07a46e6e26ea$var$getForbiddenErrorContent = (resourceId, fireAnalyticsEvent)=>{
    try {
        if (!resourceId) throw new Error('Missing resource id');
        const { sourceContentId: sourceContentId, sourceProduct: sourceProduct } = (0, $gtauf.getContentIdAndProductFromResourceId)(resourceId);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $a081b56695b04c74$export$33325aff698460b9), {
            sourceContentId: sourceContentId,
            sourceProduct: sourceProduct
        });
    } catch (error) {
        (0, $hWRJP.logException)(error, {
            location: 'editor-synced-block-renderer/SyncedBlockErrorComponent'
        });
        fireAnalyticsEvent?.((0, $cFpEg.fetchErrorPayload)(error.message));
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $f85682255cf077df$export$59b0b39f63011407), {});
    }
};
const $ea1f07a46e6e26ea$export$f4d17ad2341a04f8 = ({ error: error, isLoading: isLoading, onRetry: onRetry, resourceId: resourceId, fireAnalyticsEvent: fireAnalyticsEvent })=>{
    const getErrorContent = (0, $42omo.useMemo)(()=>{
        switch(error){
            case (0, $awHlv.SyncBlockError).Offline:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $9db02b4444c232ef$export$8a461f6033aecd80), {});
            case (0, $awHlv.SyncBlockError).Forbidden:
                return $ea1f07a46e6e26ea$var$getForbiddenErrorContent(resourceId, fireAnalyticsEvent);
            case (0, $awHlv.SyncBlockError).NotFound:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $feacbaab62ed6a89$export$3f73b17e61025be6), {});
            case (0, $awHlv.SyncBlockError).Errored:
            case (0, $awHlv.SyncBlockError).RateLimited:
            case (0, $awHlv.SyncBlockError).ServerError:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $5e5c198b585256f8$export$ca85b0be86ccfb26), {
                    onRetry: onRetry,
                    isLoading: isLoading
                });
            default:
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $f85682255cf077df$export$59b0b39f63011407), {});
        }
    }, [
        error,
        isLoading,
        onRetry,
        resourceId,
        fireAnalyticsEvent
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $e6n00.SyncBlockSharedCssClassName).error,
        children: getErrorContent
    }));
};
module.exports["SyncedBlockErrorComponent"] = $ea1f07a46e6e26ea$export$f4d17ad2341a04f8;

});

parcelRegister("1Wy2j", function(module, exports) {
/* SyncedBlockLoadingState.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $e6n00 = parcelRequire("e6n00");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");

const $ab0addd976e372f3$var$styles = {
    wrapper: "_1tkevbgk _1e0c1txw _1bah1h6o _4cvr1h6o"
};
const $ab0addd976e372f3$export$6d2e5b4986b73a9a = ()=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides
    /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $e6n00.SyncBlockSharedCssClassName).loading,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $ab0addd976e372f3$var$styles.wrapper,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                size: "small",
                label: "Loading synced content"
            })
        })
    }));
};
module.exports["SyncedBlockLoadingState"] = $ab0addd976e372f3$export$6d2e5b4986b73a9a;

});

parcelRegister("epn2u", function(module, exports) {
const $950ecc7cad6e8d10$export$e09386e914855e84 = ()=>{
    const rawSyncBlockData = typeof globalThis !== 'undefined' ? globalThis.__SSR_EDITOR_NODE_DATA_PROVIDERS_DATA__?.syncBlocks : undefined;
    if (rawSyncBlockData) return rawSyncBlockData.reduce((acc, item)=>{
        acc[item.resourceId] = item;
        return acc;
    }, {});
    return undefined;
};
module.exports["syncedBlockLoadSSRData"] = $950ecc7cad6e8d10$export$e09386e914855e84;

});

parcelRegister("edEsl", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ 
var $eGqQQ = parcelRequire("eGqQQ");


var $04e9M = parcelRequire("04e9M");


var $9wGTI = parcelRequire("9wGTI");

const $027ba4852fb11225$var$requests = new Map();
const $027ba4852fb11225$var$setCacheWithTimeout = (fileId, req)=>$027ba4852fb11225$var$requests.set(fileId, req) && void setTimeout(()=>$027ba4852fb11225$var$requests.delete(fileId), 3000);
const $027ba4852fb11225$var$globalMediaViewedListener = (options, contentType)=>{
    // To avoid case when user opens media-picker (and we don't want to call BE API after that)
    if (!options.isUserCollection) {
        // Sometimes globalEventMediaEmitter will invoke the globalMediaViewedListener callback
        // multiple times for a single `media-viewed` event. For this reason we return a cached
        // request promise if one exists
        const priorRequestForTheSameFileID = $027ba4852fb11225$var$requests.get(options?.fileId);
        return priorRequestForTheSameFileID || (()=>{
            const mediaViewedReq = (0, $9wGTI.fg)('confluence_event_notifier_deprecation') ? Promise.resolve({}) : fetch('/wiki/rest/internal/1.0/eventnotifier/notify', {
                method: 'POST',
                body: JSON.stringify({
                    attachmentViewed: {
                        fileStoreId: options.fileId
                    }
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if ((0, $9wGTI.fg)('confluence_event_notifier_updates')) (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendTrackEvent({
                    source: 'ui',
                    actionSubject: 'attachment',
                    action: 'viewed',
                    name: 'attachment viewed',
                    attributes: {
                        activationId: options.fileId,
                        pageType: contentType
                    }
                });
            });
            $027ba4852fb11225$var$setCacheWithTimeout(options.fileId, mediaViewedReq);
            return mediaViewedReq;
        })();
    }
};
let $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
// make sure currentListener is a stable reference so it can be removed by .off event handler
let $027ba4852fb11225$var$currentListener = null;
const $027ba4852fb11225$export$dbbc14ed63c88dd4 = ({ contentType: contentType })=>{
    if (!$027ba4852fb11225$var$mediaViewedListenerRegistered) {
        $027ba4852fb11225$var$currentListener = (options)=>{
            $027ba4852fb11225$var$globalMediaViewedListener(options, contentType);
        };
        (0, $eGqQQ.globalMediaEventEmitter).on('media-viewed', $027ba4852fb11225$var$currentListener);
        $027ba4852fb11225$var$mediaViewedListenerRegistered = true;
    }
};
const $027ba4852fb11225$export$29046bd16724fad9 = ()=>{
    if ($027ba4852fb11225$var$currentListener) {
        (0, $eGqQQ.globalMediaEventEmitter).off('media-viewed', $027ba4852fb11225$var$currentListener);
        $027ba4852fb11225$var$currentListener = null;
        $027ba4852fb11225$var$mediaViewedListenerRegistered = false;
    }
};
module.exports["registerGlobalMediaViewedListener"] = $027ba4852fb11225$export$dbbc14ed63c88dd4;
module.exports["removeGlobalMediaViewedListener"] = $027ba4852fb11225$export$29046bd16724fad9;

});

parcelRegister("eXfot", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $408d997ca1cff4e4$export$2fe8e9e635ca9d7a = (0, $eSUdr.default)`mutation SetBatchedTaskStatus($contentId:ID!$tasks:[InlineTask]!$trigger:PageUpdateTrigger=VIEW_PAGE){setBatchedTaskStatus(batchedInlineTasksInput:{contentId:$contentId tasks:$tasks trigger:$trigger}){success}}`;
module.exports["SetBatchedTaskStatusMutation"] = $408d997ca1cff4e4$export$2fe8e9e635ca9d7a;

});


$parcel$global.rlb("2iDj1")
//# sourceMappingURL=FullPageEditorComponent.d7a70edc.js.map
